webpackJsonp([1],{

/***/ "+5KU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+rGV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{staticClass:"wgu-app-toolbar white--text",attrs:{"color":_vm.color,"fixed":"","app":"","clipped-right":""}},[_vm._t("wgu-tb-start"),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wst-app-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("wgu-tb-after-title"),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_vm._t("wgu-tb-before-auto-buttons"),_vm._v(" "),_vm._l((_vm.tbButtons),function(tbButton,index){return [_c(tbButton.type,{key:index,tag:"component",attrs:{"icon":tbButton.icon,"text":tbButton.text,"color":_vm.color,"dark":tbButton.dark}})]}),_vm._v(" "),_vm._t("wgu-tb-after-auto-buttons"),_vm._v(" "),(_vm.menuButtons.length)?_c('v-menu',{attrs:{"offset-y":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("menu")])],1),_vm._v(" "),_c('v-list',[_vm._l((_vm.menuButtons),function(tbButton,index){return [_c(tbButton.type,{key:index,tag:"v-list-item",attrs:{"icon":tbButton.icon,"text":tbButton.text,"color":_vm.color}})]})],2)],1):_vm._e(),_vm._v(" "),_vm._t("wgu-tb-end")],2)}
var staticRenderFns = []


/***/ }),

/***/ "+u1G":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/Y57":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "04/i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_ol_Map__ = __webpack_require__("i8bC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_AppHeader__ = __webpack_require__("mUig");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_AppFooter__ = __webpack_require__("ZfcG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_AppLogo__ = __webpack_require__("qq5n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__src_components_measuretool_MeasureWin__ = __webpack_require__("lgWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__src_components_layerlist_LayerListWin__ = __webpack_require__("29fi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__src_components_infoclick_InfoClickWin__ = __webpack_require__("qUL7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__src_components_progress_MapLoadingStatus__ = __webpack_require__("novK");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-tpl',
  components: {
    'wgu-map': __WEBPACK_IMPORTED_MODULE_4__src_components_ol_Map__["a" /* default */],
    'wgu-app-header': __WEBPACK_IMPORTED_MODULE_5__components_AppHeader__["a" /* default */],
    'wgu-app-footer': __WEBPACK_IMPORTED_MODULE_6__components_AppFooter__["a" /* default */],
    'wgu-app-logo': __WEBPACK_IMPORTED_MODULE_7__src_components_AppLogo__["a" /* default */],
    'wgu-measuretool-win': __WEBPACK_IMPORTED_MODULE_8__src_components_measuretool_MeasureWin__["a" /* default */],
    'wgu-layerlist-win': __WEBPACK_IMPORTED_MODULE_9__src_components_layerlist_LayerListWin__["a" /* default */],
    'wgu-infoclick-win': __WEBPACK_IMPORTED_MODULE_10__src_components_infoclick_InfoClickWin__["a" /* default */],
    'wgu-maploading-status': __WEBPACK_IMPORTED_MODULE_11__src_components_progress_MapLoadingStatus__["a" /* default */]
  },
  data: function data() {
    return {
      isEmbedded: false,
      moduleWins: this.getModuleWinData(),
      footerTextLeft: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig.footerTextLeft,
      footerTextRight: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig.footerTextRight,
      showCopyrightYear: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig.showCopyrightYear,
      baseColor: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig.baseColor
    };
  },
  mounted: function mounted() {
    // apply the isEmbedded state to the member var
    this.isEmbedded = this.$isEmbedded;

    // make the refs (floating module window, which are not connected to their
    // related components, e.g. buttons to toggle them)
    var refs = this.$refs;
    var cmpLookup = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(refs)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var key = _step.value;

        cmpLookup[key] = refs[key][0];
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.cmpLookup = cmpLookup;
    // inform registered cmps that the app is mounted and the dynamic
    // components are available
    __WEBPACK_IMPORTED_MODULE_3__src_WguEventBus__["a" /* WguEventBus */].$emit('app-mounted');
  },

  methods: {
    /**
     * Determines the module window configuration objects from app-config:
     *     moduleWins: [
     *       {type: 'wgu-layerlist-win'},
     *       {type: 'wgu-measuretool-win'}
     *     ]
     * @return {Array} module window configuration objects
     */
    getModuleWinData: function getModuleWinData() {
      var appConfig = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig || {};
      var modulesConfs = appConfig.modules || {};
      var moduleWins = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(modulesConfs)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          var moduleOpts = appConfig.modules[key];
          if (moduleOpts.win === true) {
            moduleWins.push({
              type: key + '-win',
              draggable: moduleOpts.draggable,
              initPos: moduleOpts.initPos
            });
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return moduleWins;
    }
  }
});

/***/ }),

/***/ "0lwK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "0zZl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1SaT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__ = __webpack_require__("WaAR");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e68136_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__ = __webpack_require__("asVY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("5bzy")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e68136_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60e68136_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "1Sz8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{ 'wgu-app': true, 'wgu-app-embedded': _vm.isEmbedded },attrs:{"id":"wgu-app","data-app":""}},[_vm._t("wgu-app-begin"),_vm._v(" "),_c('wgu-app-header',{attrs:{"color":_vm.baseColor}},[_vm._t("wgu-tb-start",null,{"slot":"wgu-tb-start"}),_vm._v(" "),_vm._t("wgu-tb-after-title",null,{"slot":"wgu-tb-after-title"}),_vm._v(" "),_vm._t("wgu-tb-before-auto-buttons",null,{"slot":"wgu-tb-before-auto-buttons"}),_vm._v(" "),_vm._t("wgu-tb-after-auto-buttons",null,{"slot":"wgu-tb-after-auto-buttons"}),_vm._v(" "),_vm._t("wgu-tb-end",null,{"slot":"wgu-tb-end"})],2),_vm._v(" "),_vm._t("wgu-after-header"),_vm._v(" "),_c('wgu-app-logo'),_vm._v(" "),_vm._t("wgu-before-content"),_vm._v(" "),_c('v-content',[_c('v-container',{staticStyle:{"padding":"0"},attrs:{"id":"ol-map-container","fluid":"","fill-height":""}},[_c('wgu-map',{attrs:{"color":_vm.baseColor}}),_vm._v(" "),_c('wgu-maploading-status',{attrs:{"color":_vm.baseColor}}),_vm._v(" "),_vm._t("wgu-after-map")],2)],1),_vm._v(" "),_vm._l((_vm.moduleWins),function(moduleWin,index){return [_c(moduleWin.type,{key:index,ref:moduleWin.type,refInFor:true,tag:"component",attrs:{"color":_vm.baseColor,"draggable":moduleWin.draggable,"initPos":moduleWin.initPos}})]}),_vm._v(" "),_vm._t("wgu-before-footer"),_vm._v(" "),_c('wgu-app-footer',{attrs:{"color":_vm.baseColor,"footerTextLeft":_vm.footerTextLeft,"footerTextRight":_vm.footerTextRight,"showCopyrightYear":_vm.showCopyrightYear}}),_vm._v(" "),_vm._t("wgu-after-footer"),_vm._v(" "),_vm._t("wgu-app-end")],2)}
var staticRenderFns = []


/***/ }),

/***/ "1jdk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1l2W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("ifoU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_proj_Projection__ = __webpack_require__("7rnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_proj__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_Url__ = __webpack_require__("v9hS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_extent__ = __webpack_require__("/LWt");








/**
 * Class holding the logic for permalinks.
 */

var PermalinkController = function () {
  function PermalinkController(map, permalinkConf) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PermalinkController);

    this.map = null;
    this.shouldUpdate = false;
    this.projection = null;
    this.conf = null;
    this.urlParams = null;

    this.map = map;
    this.conf = permalinkConf || {};
    this.projection = this.conf.projection ? new __WEBPACK_IMPORTED_MODULE_3_ol_proj_Projection__["a" /* default */]({ 'code': this.conf.projection }) : null;
    this.conf.paramPrefix = this.conf.paramPrefix || '';
    this.conf.location = this.conf.location || 'hash';
    this.conf.separator = this.conf.location === 'hash' ? '#' : '?';
    this.conf.history = this.conf.history ? this.conf.history : false;
    this.conf.extent = this.conf.extent ? this.conf.extent : false;
    this.conf.layers = this.conf.layers ? this.conf.layers : false;
    this.conf.precision = this.conf.precision ? this.conf.precision : 4;
    this.urlParams = __WEBPACK_IMPORTED_MODULE_5__util_Url__["a" /* default */].getParams(this.conf.location);
    this.layerListeners = [];
  }

  /**
   * Initializes the map permalink functionality:
   * Registers a 'moveend' event to update the permalink
   * 'hoverAttribute' if the layer is configured as 'hoverable'
   */

  /* the OL map for permalink */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PermalinkController, [{
    key: 'setup',
    value: function setup() {
      var _this = this;

      this.shouldUpdate = true;

      // Listen to map state changes (pan, zoom)
      this.map.on('moveend', function () {
        _this.onMapChange();
      });

      // Listen to visibility changes in Map Layers.
      this.subscribeLayers();

      // Listen to Layer Collection (dynamically Layers added/removed)
      this.map.getLayers().on('change:length', function () {
        _this.subscribeLayers();
      });

      if (this.conf.history === false) {
        return;
      }

      // restore the view state when navigating through the history (browser back/forward buttons), see
      // https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
      window.addEventListener('popstate', function (event) {
        if (event.state === null) {
          return;
        }

        var view = _this.map.getView();
        var state = event.state;

        _this.shouldUpdate = false;

        view.setRotation(state.rotation);

        // Use extent (bbox) or center+zoom based on config
        if (_this.conf.extent) {
          _this.applyExtent(state.extent);
        } else {
          _this.applyCenter(state.center);
        }

        // somehow we also need zoom (or resolution) for extent:
        // See: https://stackoverflow.com/questions/47770782/openlayers-fit-to-current-extent-is-zooming-out
        view.setZoom(state.zoom);

        if (_this.conf.layers) {
          _this.applyLayers(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(state.layers.map(function (lid) {
            return [lid, lid];
          })));
        }
      });
    }

    /**
     * Subscribe to Layer visibility changes.
     */

  }, {
    key: 'subscribeLayers',
    value: function subscribeLayers() {
      var _this2 = this;

      // First unsubscribe from all
      this.unsubscribeLayers();

      // Listen to each Layer's visibility changes.
      this.map.getLayers().forEach(function (layer) {
        var key = layer.on('change:visible', function () {
          _this2.onMapChange();
        });
        _this2.layerListeners.push({ 'key': key, 'layer': layer });
      });
    }

    /**
     * Unsubscribe to Layer visibility changes.
     */

  }, {
    key: 'unsubscribeLayers',
    value: function unsubscribeLayers() {
      // Listen to each Layer's visibility changes.
      this.layerListeners.forEach(function (item) {
        item.layer.un(item.key.type, item.key.listener);
      });
      this.layerListeners = [];
    }

    /**
     * Applies map (View) rotation, center+zoom-level or extent
     * from permalink params in current URL 'location'
     */

  }, {
    key: 'apply',
    value: function apply() {
      var permalinkParams = __WEBPACK_IMPORTED_MODULE_5__util_Url__["a" /* default */].getParams(this.conf.location);
      var prefix = this.conf.paramPrefix;
      var mapView = this.map.getView();
      var r = prefix + 'r';
      var c = prefix + 'c';
      var e = prefix + 'e';
      var z = prefix + 'z';
      var l = prefix + 'l';

      if (permalinkParams[r]) {
        mapView.setRotation(parseFloat(permalinkParams[r]));
      }

      // Both extent (bbox) or center+zoom supported.
      if (permalinkParams[e]) {
        var extent = permalinkParams[e].split(',').map(function (n) {
          return parseFloat(n);
        });
        this.applyExtent(extent);
      } else if (permalinkParams[c]) {
        var center = permalinkParams[c].split(',').map(function (n) {
          return parseFloat(n);
        });
        this.applyCenter(center);
      }

      // Always set zoom, even with extent
      // See: https://stackoverflow.com/questions/47770782/openlayers-fit-to-current-extent-is-zooming-out
      if (permalinkParams[z]) {
        mapView.setZoom(parseFloat(permalinkParams[z]));
      }

      // Set layer(s) visible
      if (permalinkParams[l]) {
        this.applyLayers(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a(permalinkParams[l].split(',').map(function (lid) {
          return [lid, lid];
        })));
      }
    }

    /**
     * Make only the layers for given array of layer ids visible.
     */

  }, {
    key: 'applyLayers',
    value: function applyLayers(layers) {
      if (!layers) {
        return;
      }
      this.map.getLayers().forEach(function (layer) {
        var layerId = layer.get('lid');
        layer.setVisible(layerId === layers.get(layerId));
      });
    }

    /**
     * Position map at provided center.
     */

  }, {
    key: 'applyCenter',
    value: function applyCenter(center) {
      if (!center) {
        return;
      }
      var mapView = this.map.getView();

      // Permalink coordinates may have specific Projection like WGS84
      if (this.projection) {
        center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_proj__["f" /* transform */])(center, this.projection, mapView.getProjection());
      }

      mapView.setCenter(center);
    }

    /**
     * Position map at provided map extent.
     */

  }, {
    key: 'applyExtent',
    value: function applyExtent(extent) {
      if (!extent) {
        return;
      }
      var mapView = this.map.getView();
      // Permalink coordinates may have specific Projection like WGS84
      if (this.projection) {
        extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ol_extent__["h" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_proj__["h" /* getTransform */])(this.projection, mapView.getProjection()));
      }

      // Fit the map in extent
      mapView.fit(extent, this.map.getSize());
    }

    /**
     * Get the URL parameter permalink string as query or hash.
     */

  }, {
    key: 'getParamStr',
    value: function getParamStr() {
      var round = function round(num, places) {
        return +(Math.round(num + 'e+' + places) + 'e-' + places);
      };

      var state = this.getState();
      var prefix = this.conf.paramPrefix;
      var prec = this.conf.precision;

      // Use extent (bbox) or center+zoom based on config
      this.urlParams[prefix + 'z'] = '' + round(state.zoom, prec);
      if (this.conf.extent) {
        this.urlParams[prefix + 'e'] = state.extent.map(function (n) {
          return round(n, prec);
        }).join(',');
      } else {
        this.urlParams[prefix + 'c'] = state.center.map(function (n) {
          return round(n, prec);
        }).join(',');
      }
      this.urlParams[prefix + 'r'] = '' + round(state.rotation, prec);

      if (this.conf.layers) {
        this.urlParams[prefix + 'l'] = state.layers.join(',');
      }

      return this.conf.separator + __WEBPACK_IMPORTED_MODULE_5__util_Url__["a" /* default */].toQueryString(this.urlParams);
    }

    /**
     * Get full URL with permalink string for sharing.
     */

  }, {
    key: 'getShareUrl',
    value: function getShareUrl() {
      return location.href.split(this.conf.separator)[0] + this.getParamStr();
    }

    /**
     * Get (IFrame) code fragment for embedding the permalink in an HTML page.
     */

  }, {
    key: 'getEmbedHTML',
    value: function getEmbedHTML() {
      var mapSize = this.map.getSize();

      return '<iframe width="' + mapSize[0] + '" height="' + mapSize[1] + '" src="' + this.getShareUrl() + '" style="border:none;"></iframe>';
    }

    /**
     * Get array of visible layer id's.
     */

  }, {
    key: 'getLayerIds',
    value: function getLayerIds() {
      return this.map.getLayers().getArray().filter(function (layer) {
        return !!layer.get('lid') && layer.getVisible();
      }).map(function (layer) {
        return layer.get('lid');
      });
    }

    /**
     * Get total State of the Map.
     */

  }, {
    key: 'getState',
    value: function getState() {
      var mapView = this.map.getView();
      var center = mapView.getCenter();
      var extent = mapView.calculateExtent();

      // Optionally reproject to permalink projection (e.g. WGS84 on WebMerc).
      if (this.projection) {
        center = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_proj__["f" /* transform */])(center, mapView.getProjection(), this.projection);
        extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_ol_extent__["h" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_proj__["h" /* getTransform */])(mapView.getProjection(), this.projection));
      }
      return {
        zoom: mapView.getZoom(),
        center: center,
        extent: extent,
        rotation: mapView.getRotation(),
        layers: this.getLayerIds()
      };
    }

    /**
     * Callback when Map View has changed, e.g. 'moveend' or a Layer's visibility.
     */

  }, {
    key: 'onMapChange',
    value: function onMapChange() {
      // console.log('mapchange');
      if (!this.shouldUpdate) {
        // do not update the URL when the view was changed in the 'popstate' handler
        this.shouldUpdate = true;
        return;
      }
      if (this.conf.history === false) {
        return;
      }
      // This changes the URL in address bar.
      window.history.pushState(this.getState(), 'map', this.getParamStr());
    }
  }]);

  return PermalinkController;
}();

/* harmony default export */ __webpack_exports__["a"] = (PermalinkController);

/***/ }),

/***/ "1pk9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_DraggableWin_js__ = __webpack_require__("MPh8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LayerList__ = __webpack_require__("mucN");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlist-win',
  directives: {
    DraggableWin: __WEBPACK_IMPORTED_MODULE_0__directives_DraggableWin_js__["a" /* DraggableWin */]
  },
  components: {
    'wgu-layerlist': __WEBPACK_IMPORTED_MODULE_1__LayerList__["a" /* default */]
  },
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    icon: { type: String, required: false, default: 'layers' },
    title: { type: String, required: false, default: 'Layers' },
    draggable: { type: Boolean, required: false, default: true },
    initPos: { type: Object, required: false }
  },
  data: function data() {
    return {
      moduleName: 'wgu-layerlist',
      show: false,
      left: this.initPos ? this.initPos.left + 'px' : '10px',
      top: this.initPos ? this.initPos.top + 'px' : '70px'
    };
  }
});

/***/ }),

/***/ "29fi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerListWin_vue__ = __webpack_require__("1pk9");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e1b79c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListWin_vue__ = __webpack_require__("ZcvY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("R6sm")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerListWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e1b79c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_75e1b79c_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerListWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3h5C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.toggleUi}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []


/***/ }),

/***/ "4z3x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__directives_DraggableWin__ = __webpack_require__("MPh8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MeasureTypeChooser__ = __webpack_require__("w/12");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MeasureResult__ = __webpack_require__("cspx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OlMeasureController__ = __webpack_require__("VT4C");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measuretool-win',
  directives: {
    DraggableWin: __WEBPACK_IMPORTED_MODULE_0__directives_DraggableWin__["a" /* DraggableWin */]
  },
  components: {
    'wgu-measure-type-chooser': __WEBPACK_IMPORTED_MODULE_2__MeasureTypeChooser__["a" /* default */],
    'wgu-measure-result': __WEBPACK_IMPORTED_MODULE_3__MeasureResult__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_Mapable__["a" /* Mapable */]],
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    icon: { type: String, required: false, default: 'photo_size_select_small' },
    title: { type: String, required: false, default: 'Measure' },
    draggable: { type: Boolean, required: false, default: true },
    initPos: { type: Object, required: false }
  },
  data: function data() {
    return {
      moduleName: 'wgu-measuretool',
      measureGeom: null,
      measureType: 'distance',
      show: false,
      left: this.initPos ? this.initPos.left + 'px' : '0',
      top: this.initPos ? this.initPos.top + 'px' : '0'
    };
  },

  watch: {
    show: function show() {
      var me = this;
      if (me.show === true) {
        me.olMapCtrl.addInteraction(me.measureType, me.onMeasureVertexSet);
      } else {
        me.olMapCtrl.removeInteraction();
      }
    },
    measureType: function measureType() {
      var me = this;
      // reset old geom
      me.measureGeom = {};
      me.olMapCtrl.addInteraction(me.measureType, me.onMeasureVertexSet);
    }
  },
  methods: {
    /**
     * Applies the changed measure value to this.measureType.
     * Called as callback of MeasureTypeChooser
     *
     * @param  {String} newMeasureType New measure type
     * @param  {String} oldMeasureType Old measure type
     */
    applyMeasureType: function applyMeasureType(newMeasureType, oldMeasureType) {
      this.measureType = newMeasureType;
    },

    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     */
    onMapBound: function onMapBound() {
      var me = this;
      var measureConf = me.$appConfig.modules[me.moduleName] || {};
      this.olMapCtrl = new __WEBPACK_IMPORTED_MODULE_4__OlMeasureController__["a" /* default */](me.map, measureConf);

      me.olMapCtrl.createMeasureLayer();
    },

    /**
     * Callback function executed when user sets a measure point on the map.
     *
     * @param  {ol/geom/Geometry} geom The geometry object of the map
     */
    onMeasureVertexSet: function onMeasureVertexSet(geom) {
      // wrap geom into object, otherwise the injection into childs does
      // not work. Maybe the OL object does not feel changed for Vue
      this.measureGeom = {
        geom: geom
      };
    }
  }
});

/***/ }),

/***/ "5bzy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6ANF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6vBf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card',{directives:[{name:"draggable-win",rawName:"v-draggable-win",value:(_vm.draggable),expression:"draggable"}],staticClass:"wgu-measurewin",style:({ left: _vm.left, top: _vm.top })},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-app-bar-nav-icon',{on:{"click":function($event){_vm.show=false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('wgu-measure-type-chooser',{attrs:{"measureType":_vm.measureType},on:{"wgu-measuretype-change":_vm.applyMeasureType}})],1),_vm._v(" "),_c('v-card-actions',[_c('wgu-measure-result',{attrs:{"measureGeom":_vm.measureGeom}})],1)],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "6yqd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.logoSrc)?_c('v-avatar',{staticClass:"wgu-app-logo",attrs:{"width":_vm.logoWidth,"height":_vm.logoHeight,"tile":true}},[_c('img',{attrs:{"src":_vm.logoSrc,"alt":"App Logo"}})]):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "7OTJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    icon: { type: String, required: false, default: 'help' },
    title: { type: String, required: false, default: 'About' },
    headline: { type: String, required: false, default: 'About Wegue' },
    content: { type: String, required: false, default: '<h3>WebGIS with OpenLayers and Vue.js</h3> Template and re-usable components for webmapping applications with OpenLayers and Vue.js' },
    infoLink: { type: String, required: false, default: 'https://github.com/meggsimum/wegue' },
    infoLinkText: { type: String, required: false, default: 'More info' }
  },
  data: function data() {
    return {
      show: false
    };
  },

  methods: {
    onWinXClose: function onWinXClose() {
      this.$emit('winxclose');
    }
  }
});

/***/ }),

/***/ "7bKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-img',{attrs:{"src":"static/data/wnstr-reise/Haus-der-Deutschen-Weinstrasse.jpg","aspect-ratio":"1.5"}}),_vm._v(" "),_c('v-card-title',{staticClass:"wsr-text",attrs:{"primary-title":""}},[_c('span',{staticClass:"wsr-start-credit"},[_vm._v("\n      Foto: ©Verbandsgemeinde Grünstadt-Land (via\n      "),_c('a',{attrs:{"href":"https://commons.wikimedia.org/wiki/File:Haus-der-Deutschen-Weinstrasse.jpg"}},[_vm._v("Wikimedia Commons")]),_vm._v(")\n    ")]),_vm._v(" "),_c('div',[_c('h3',{staticClass:"headline mb-0 wsr-title"},[_vm._v("Weinstraßenreise")]),_vm._v(" "),_c('div',[_vm._v("\n        Eine interaktive Reise entlang der Deutschen Weinstraße:\n        von Bockenheim bis nach Schweigen.\n      ")]),_vm._v(" "),(!_vm.isMobile)?_c('p',{staticClass:"wsr-start-instr"},[_vm._v("\n        Fahren Sie mit der Maus über die "),_c('img',{attrs:{"src":"static/data/wnstr-reise/vineyard-white.png","alt":""}}),_vm._v("-Icons,\n        um sich den Ortsnamen anzeigen zu lassen.\n      ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"wsr-start-instr"},[_vm._v("\n        Für weitere Detail-Informationen zu einem Ort Ihres Interesses klicken / tippen Sie auf das\n        "),_c('img',{attrs:{"src":"static/data/wnstr-reise/vineyard-white.png","alt":""}}),_vm._v("-Icon.\n      ")])])]),_vm._v(" "),(_vm.isMobile)?_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"gray"},on:{"click":function($event){_vm.showMe=false}}},[_vm._v("Zur Karte")])],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "97QL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "AdsX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"wgu-helpwin"},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{on:{"click":_vm.onWinXClose}},[_vm._v("close")])],1),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.headline))]),_vm._v(" "),_c('div',{},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.content)}})])])]),_vm._v(" "),_c('v-card-actions',[_c('a',{staticClass:"info-link red--text darken3",attrs:{"href":_vm.infoLink,"target":"_blank"}},[_vm._v(_vm._s(_vm.infoLinkText))])])],1)}
var staticRenderFns = []


/***/ }),

/***/ "CHdZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wsr-infowin',
  props: {
    color: { type: String, required: false, default: 'rgba(135, 211, 124, 1)' },
    icon: { type: String, required: false, default: 'info' },
    dark: { type: Boolean, required: false, default: false },
    title: { type: String, required: false, default: 'Über Weinstraßenreise' },
    text: { type: String, required: false }
  },
  data: function data() {
    return {
      show: false,
      logoSrc: 'static/data/wnstr-reise/meggsimum-logo-s-rgb-980.jpg'
    };
  }
});

/***/ }),

/***/ "DIZr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.onClick}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []


/***/ }),

/***/ "DcW1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-infoclick-btn',
  props: {
    icon: { type: String, required: false, default: 'info' },
    text: { type: String, required: false, default: '' },
    dark: { type: Boolean, required: false, default: false }
  },
  data: function data() {
    return {
      moduleName: 'wgu-infoclick'
    };
  },
  created: function created() {
    var me = this;
    // TODO move to a father class
    __WEBPACK_IMPORTED_MODULE_1__WguEventBus__["a" /* WguEventBus */].$on('app-mounted', function () {
      me.win = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.cmpLookup[me.moduleName + '-win'];
    });
    if (!me.win) {
      me.win = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.cmpLookup[me.moduleName + '-win'];
    }
  },

  methods: {
    toggleUi: function toggleUi() {
      // TODO move to a father class
      this.win.show = !this.win.show;
    }
  }
});

/***/ }),

/***/ "EJOe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"measure-result"},[_vm._v("\n    LENGTH: "+_vm._s(_vm.distance)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"measure-result"},[_vm._v("\n    AREA: "+_vm._s(_vm.area)+"\n  ")])])}
var staticRenderFns = []


/***/ }),

/***/ "F+zM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_ol_geom_LineString__ = __webpack_require__("grfP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_geom_Polygon__ = __webpack_require__("ZYQ1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__ = __webpack_require__("1avf");
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measure-result',
  props: {
    measureGeom: { type: Object }
  },
  data: function data() {
    return {
      area: ' -- ',
      distance: ' -- '
    };
  },

  watch: {
    measureGeom: function measureGeom() {
      var me = this;
      var geom = me.measureGeom.geom;
      var output = void 0;
      if (geom instanceof __WEBPACK_IMPORTED_MODULE_1_ol_geom_Polygon__["a" /* default */]) {
        output = me.formatArea(geom);
        me.area = output;
      } else if (geom instanceof __WEBPACK_IMPORTED_MODULE_0_ol_geom_LineString__["a" /* default */]) {
        output = me.formatLength(geom);
        me.distance = output;
      } else {
        me.area = ' -- ';
        me.distance = ' -- ';
      }
    }
  },
  methods: {
    /**
     * Calculates and formats the length of the given line.
     *
     * @param  {ol.geom.LineString} line The LineString object to calculate length for
     */
    formatLength: function formatLength(line) {
      var length = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__["c" /* getLength */])(line);
      var output = void 0;
      if (length > 100) {
        output = Math.round(length / 1000 * 100) / 100 + ' ' + 'km';
      } else {
        output = Math.round(length * 100) / 100 + ' ' + 'm';
      }
      return output;
    },

    /**
     * Calculates and formats the area of the given polygon.
     *
     * @param  {ol.geom.Polygon} polygon The Polygon object to calculate area for
     */
    formatArea: function formatArea(polygon) {
      var area = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_ol_sphere_js__["d" /* getArea */])(polygon);
      var output = void 0;
      if (area > 10000) {
        output = Math.round(area / 1000000 * 100) / 100 + ' ' + 'km²';
      } else {
        output = Math.round(area * 100) / 100 + ' ' + 'm²';
      }
      return output;
    }
  }
});

/***/ }),

/***/ "FO/s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GgOu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__WguAppTemplate_vue__ = __webpack_require__("c0QU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Sidebar__ = __webpack_require__("S36s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_InfoWin__ = __webpack_require__("eRtg");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app',
  components: {
    'wgu-app-tpl': __WEBPACK_IMPORTED_MODULE_1__WguAppTemplate_vue__["a" /* default */],
    'wsr-sidebar': __WEBPACK_IMPORTED_MODULE_2__components_Sidebar__["a" /* default */],
    'wsr-infowin': __WEBPACK_IMPORTED_MODULE_3__components_InfoWin__["a" /* default */]
  },
  data: function data() {
    return {
      showRightSidebar: true,
      baseColor: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$appConfig.baseColor
    };
  },
  mounted: function mounted() {
    console.log();
  },

  methods: {}
});

/***/ }),

/***/ "JwL6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WikipediaApi__ = __webpack_require__("T3i0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_Device__ = __webpack_require__("y65X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Startscreen__ = __webpack_require__("Q9Yo");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wsr-sidebar',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__src_mixins_Mapable__["a" /* Mapable */]],
  components: {
    'wsr-startscreen': __WEBPACK_IMPORTED_MODULE_5__Startscreen__["a" /* default */]
  },
  props: {
    value: { type: Boolean },
    color: { type: String, required: false, default: 'red darken-3' }
  },
  data: function data() {
    return {
      showMe: this.value,
      showStartscreen: true,
      featProperties: null,
      title: '',
      description: '',
      imgDesc: '',
      imgPath: '',
      website: null
    };
  },

  computed: {
    isMobile: function isMobile() {
      return __WEBPACK_IMPORTED_MODULE_3__util_Device__["a" /* Device */].isMobile();
    }
  },
  watch: {
    showMe: function showMe(val) {
      this.$emit('toggle', val);
    }
  },
  mounted: function mounted() {
    var me = this;

    __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__["a" /* WguEventBus */].$on('wsr-sidebar-hide', function () {
      me.showMe = false;
    });

    __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__["a" /* WguEventBus */].$on('wsr-feature-click', function (clickFeature) {
      var feat = clickFeature;
      if (!feat) {
        me.showStartscreen = true;
        return;
      }

      var villageName = feat.get('name');
      var wikipediaTitle = feat.get('wikipedia');
      var wikipediaQuery = wikipediaTitle || villageName;

      me.title = villageName;

      __WEBPACK_IMPORTED_MODULE_2__WikipediaApi__["a" /* WikipediaApi */].loadArticle(wikipediaQuery).then(function (wikipediaPages) {
        var firstPage = wikipediaPages[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(wikipediaPages)[0]];

        if (firstPage) {
          me.showStartscreen = false;
          me.description = firstPage.extract;
          me.website = 'https://de.wikipedia.org/wiki/' + wikipediaTitle || villageName;

          var randomImgName = __WEBPACK_IMPORTED_MODULE_2__WikipediaApi__["a" /* WikipediaApi */].getRandomImageName(firstPage);
          if (randomImgName !== null) {
            __WEBPACK_IMPORTED_MODULE_2__WikipediaApi__["a" /* WikipediaApi */].loadImage(randomImgName).then(function (imgJson) {
              var firstImg = imgJson[__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(imgJson)[0]];
              if (firstImg && firstImg.imageinfo && firstImg.imageinfo.length > 0) {
                me.imgPath = firstImg.imageinfo[0].url;
                me.imgDesc = firstImg.imageinfo[0].descriptionshorturl;
                // TODO catch error of promise
              }
            });
          }
        }
      });

      me.showMe = true;
    });
  },

  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     */
    onMapBound: function onMapBound() {
      var me = this;

      me.map.on('singleclick', me.onMapClick);
    },

    /**
     * Handler for 'singleclick' on the map.
     * Collects data and passes it to corresponding objects.
     *
     * @param  {ol/MapBrowserEvent} evt The OL event of 'singleclick' on the map
     */
    onMapClick: function onMapClick(evt) {
      var me = this;
      var feature = me.map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
        return feature;
      });

      __WEBPACK_IMPORTED_MODULE_1__src_WguEventBus__["a" /* WguEventBus */].$emit('wsr-feature-click', feature);
    }
  }
});

/***/ }),

/***/ "K3zS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500","hide-overlay":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"slot":"activator","icon":"","dark":_vm.dark},slot:"activator"},on),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")],1)]}}]),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "),_c('v-card',{staticClass:"wsr-infowin"},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":_vm.dark}},[_c('v-toolbar-side-icon',[_c('v-icon',[_vm._v(_vm._s(_vm.icon))])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-side-icon',{on:{"click":function($event){_vm.show=false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"wsr-text",attrs:{"primary-title":""}},[_c('h3',[_vm._v("Info")]),_vm._v(" "),_c('p',[_vm._v("\n          Weinstraßenreise zeigt die Ortschaften, die an der Deutschen Weinstraße\n          zwischen Bockenheim und Schweigen liegen auf einer interaktiven Webkarte,\n          einem sogenannten "),_c('a',{attrs:{"href":"https://de.wikipedia.org/wiki/Web_GIS","target":"_blank"}},[_vm._v("WebGIS")]),_vm._v(".\n          Neben der Karteninformation können zu\n          jeder Ortschaft weiterführende Informationen abgerufen und angezeigt werden.\n          Diese Informationen stammen aus der "),_c('a',{attrs:{"href":"https://de.wikipedia.org/wiki/Wikipedia:Hauptseite","target":"_blank"}},[_vm._v("deutschsprachigen Wikipedia")]),_vm._v(".\n        ")]),_vm._v(" "),_c('p',[_vm._v("\n          Die Kartenanwendung basiert auf freien Geodaten ("),_c('a',{attrs:{"href":"https://www.openstreetmap.org/","target":"_blank"}},[_vm._v("OpenStreetMap")]),_vm._v("),\n          sowie auf freier und quelloffener Software (u.a. "),_c('a',{attrs:{"href":"https://meggsimum.de/wegue/","target":"_blank"}},[_vm._v("Wegue")]),_vm._v(").\n          Die OpenStreetMap Daten wurden mit der Software "),_c('a',{attrs:{"href":"https://qgis.org/en/site/","target":"_blank"}},[_vm._v("QGIS")]),_vm._v(" aufbereitet.\n        ")]),_vm._v(" "),_c('h3',[_vm._v("Idee, Entwicklung und Bereitstellung")]),_vm._v(" "),_c('a',{attrs:{"href":"https://meggsimum.de/","target":"_blank"}},[_c('v-img',{attrs:{"src":_vm.logoSrc,"contain":"","aspect-ratio":"2.5","min-width":"290"}})],1),_vm._v(" "),_c('p',[_vm._v("\n          Christian Mayer"),_c('br'),_vm._v("\n          Schillerstraße 2a"),_c('br'),_vm._v("\n          67112 Mutterstadt"),_c('br'),_c('br'),_vm._v("\n          Falls Sie Fragen, Anregungen oder Interesse an einer solchen\n          Kartenanwendung haben können Sie über die Email-Adresse\n          "),_c('a',{attrs:{"href":"mailto:info@meggsimum.de","target":"_blank"}},[_vm._v("info-(at)-meggsimum-(punkt)-de")]),_vm._v("\n          mit uns in Kontakt treten.\n        ")]),_vm._v(" "),_c('h3',[_vm._v("Credits / Lizenzangaben")]),_vm._v(" "),_c('p',[_vm._v("\n          Detailtexte aus Wikipedia sind unter der Lizenz\n          „"),_c('a',{attrs:{"href":"https://de.wikipedia.org/wiki/Wikipedia:Lizenzbestimmungen_Commons_Attribution-ShareAlike_3.0_Unported","target":"_blank"}},[_vm._v("Creative Commons Attribution/Share Alike")]),_vm._v("“\n          verfügbar.\n          "),_c('br'),_vm._v("\n          Informationen zu den Urhebern und zum Lizenzstatus eingebundener Mediendateien (Bilder)\n          können im Regelfall durch Anklicken dieser abgerufen werden (wenn nicht anderweitig angegeben).\n        ")]),_vm._v(" "),_c('p',{staticClass:"wsr-icon-text"},[_c('img',{attrs:{"src":"static/data/wnstr-reise/vineyard-white.png","alt":""}}),_vm._v("\n           -Icon mit "),_c('a',{attrs:{"href":"https://mapicons.mapsmarker.com/","target":"_blank"}},[_vm._v("Maps Icons Collection")]),_vm._v(" erstellt, lizenziert unter\n           "),_c('a',{attrs:{"href":"http://creativecommons.org/licenses/by-sa/3.0/","target":"_blank"}},[_vm._v("Creative Commons Attribution-Share Alike 3.0 Unported")])]),_vm._v(" "),_c('p',{staticClass:"wsr-icon-text"},[_c('img',{attrs:{"src":"static/data/wnstr-reise/deutsche-weinstrasse.svg","alt":"","height":"30"}}),_vm._v("\n           -Icon im Original von "),_c('a',{attrs:{"href":"https://commons.wikimedia.org/wiki/User:Skarabeusz","target":"_blank"}},[_vm._v("Skarabeusz")]),_vm._v(" erstellt,\n           lizensiert unter "),_c('a',{attrs:{"href":"https://en.wikipedia.org/wiki/en:GNU_Free_Documentation_License","target":"_blank"}}),_vm._v("GNU Free Documentation License\n           bezogen über "),_c('a',{attrs:{"href":"https://commons.wikimedia.org/wiki/File:Deutsche-Weinstrasse.svg","target":"_blank"}},[_vm._v("Wikimedia Commons")])]),_vm._v(" "),_c('p',[_vm._v("\n          Kartendaten (Orte): © "),_c('a',{attrs:{"href":"http://www.openstreetmap.org/copyright","target":"_blank"}},[_vm._v("OpenStreetMap")]),_vm._v("-Mitwirkende,\n          lizenziert unter "),_c('a',{attrs:{"href":"http://opendatacommons.org/licenses/odbl/","target":"_blank"}},[_vm._v("Open Data Commons Open Database License (ODbL)")])]),_vm._v(" "),_c('p',[_vm._v("\n          Hintergrundkarte (WMS): © "),_c('a',{attrs:{"href":"http://www.mundialis.de/","target":"_blank"}},[_vm._v("mundialis")])])])],1)],1)}
var staticRenderFns = []


/***/ }),

/***/ "L1xf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors__ = __webpack_require__("IHMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Color__ = __webpack_require__("nF/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_proj_js__ = __webpack_require__("yGLh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_coordinate__ = __webpack_require__("IZoy");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-coords-table',
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    coordsData: { type: Object },
    showMapPos: { type: Boolean, required: false, default: true },
    showWgsPos: { type: Boolean, required: false, default: true },
    showHdms: { type: Boolean, required: false, default: true }
  },
  data: function data() {
    return {
      coordRows: null
    };
  },
  computed: {
    tableStyles: function tableStyles() {
      // calculate border color of tables due to current color property
      var borderColor = this.color;
      if (!__WEBPACK_IMPORTED_MODULE_2__util_Color__["a" /* default */].isCssColor(this.color)) {
        var _color$toString$trim$ = this.color.toString().trim().split(' ', 2),
            _color$toString$trim$2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_color$toString$trim$, 2),
            colorName = _color$toString$trim$2[0],
            colorModifier = _color$toString$trim$2[1];

        borderColor = __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default.a[colorName];
        if (colorModifier) {
          colorModifier = colorModifier.replace('-', '');
          borderColor = __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default.a[colorName][colorModifier];
        }
      }
      return {
        'border': '2px solid ' + borderColor
      };
    }
  },
  methods: {},
  watch: {
    coordsData: function coordsData() {
      var me = this;
      var coordinate = me.coordsData.coordinate;
      var projection = me.coordsData.projection;
      var coordinateWgs84 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj_js__["f" /* transform */])(coordinate, projection, 'EPSG:4326');
      var coordRows = {};

      if (me.showMapPos) {
        // show coordinate in map' SRS
        coordRows['MAP PROJ'] = coordinate[1].toFixed(2) + ' ' + coordinate[0].toFixed(2);
      }
      if (me.showWgsPos) {
        // show coordinate in WGS 84
        var _coordinateWgs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_proj_js__["f" /* transform */])(coordinate, projection, 'EPSG:4326');
        coordRows['WGS 84'] = _coordinateWgs[1].toFixed(7) + '° ' + _coordinateWgs[0].toFixed(7) + '°';
      }
      if (me.showHdms) {
        // show coordinate in WGS 84 as formatted degree / min / secs
        var hdms = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_ol_coordinate__["d" /* toStringHDMS */])(coordinateWgs84);
        coordRows['HDMS'] = hdms;
      }

      me.coordRows = coordRows;
    }
  }
});

/***/ }),

/***/ "MPh8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DraggableWin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


/**
 * Directive to make a window component draggable by dragging it's header.
 * Proudly inspired by and most of the essential code taken from
 * https://github.com/branu-ws/v-drag/blob/master/src/index.js
 */
var DraggableWin = {
  dragConfig: {
    // if this is present, only a specific area of the draggable will respond to
    // dragging (e. g. header bar).
    draggableElementSelector: null,
    down: false,
    height: 0,
    width: 0,
    initialX: 0,
    initialY: 0,
    constraintToWindow: true,
    cursorPreviousX: 0,
    cursorPreviousY: 0,
    draggerOffsetLeft: 0,
    draggerOffsetTop: 0,
    overlay: null,
    draggableEl: null,
    initialZIndex: undefined
  },

  bind: function bind(elmnt, binding, vnode) {
    if (binding.value === false) {
      // disable this directive if set to v-draggable-win="false"
      return;
    }
    // get the header element to bind the events on it
    var header = elmnt.querySelector('div.wgu-win-title');
    if (!header) {
      return;
    }
    var dragConfig = DraggableWin.dragConfig;

    // restrict the dragging at least to window title
    dragConfig.draggableElementSelector = binding.arg || 'wgu-win-title';

    // set cursor so it's signal that the user can drag the window
    header.style.cursor = 'move';

    elmnt.addEventListener('mouseup', function (e) {
      return DraggableWin.mouseup(e, elmnt, dragConfig);
    });
    elmnt.addEventListener('mousedown', function (e) {
      return DraggableWin.mousedown(e, elmnt, dragConfig);
    });
    elmnt.addEventListener('mousemove', function (e) {
      return DraggableWin.mousemove(e, elmnt, dragConfig);
    });
    setDraggerOffset(elmnt, dragConfig);
    dragConfig.initialZIndex = elmnt.style.zIndex;

    /**
     * Creates an overlay in order to bind the mouse events to it.
     * @private
     */
    function createOverlay(e, el, _data) {
      var overlay = document.createElement('div');
      overlay.setAttribute('style', '\n        width: 100vw;\n        height: 100vh;\n        position: absolute;\n        top: 0;\n        left: 0;\n        z-index: 10000;\n      ');
      overlay.addEventListener('mouseup', function (e) {
        return mouseup(e, el, _data);
      });
      overlay.addEventListener('mousedown', function (e) {
        return mousedown(e, el, _data);
      });
      overlay.addEventListener('mousemove', function (e) {
        return mousemove(e, el, _data);
      });
      document.body.appendChild(overlay);

      return overlay;
    }

    /**
     * Checks if the given selector (id or class) occurs in the given path
     */
    function checkIfSelectorInPath(selector, path) {
      for (var i = 0; i < path.length; i++) {
        // check for ID
        if (path[i].id === selector) {
          return true;
        }
        // also check for a class name
        if (path[i].classList && path[i].classList.contains(selector)) {
          return true;
        }
      }
      return false;
    }

    /**
     * Adjusts element's z-index.
     */
    function adjustElementZIndex(el, index) {
      el.style.zIndex = index;
    }

    /**
     * Event handler for mouse down.
     */
    function mousedown(e, el, _data) {
      // if the user set a argument to v-drag,
      // it means they only want a specific area to be draggable
      // eg: `v-drag:drag-header` means only the element with
      // id="drag-header" or class="drag-header" should be draggable.
      // If the user clicked another area, do nothing.
      // By default it is restricted to class="wgu-win-title"
      if (_data.draggableElementSelector && !checkIfSelectorInPath(_data.draggableElementSelector, e.path)) {
        return;
      }

      if (_data.overlay) {
        _data.overlay.remove();
      }
      // set the width each click
      // just in case it changed since last time (by external plugin, for example)
      _data.width = el.offsetWidth;
      _data.height = el.offsetHeight;
      _data.down = true;
      _data.initialX = e.clientX;
      _data.initialY = e.clientY;
      var overlay = createOverlay(e, el, _data);
      _data.overlay = overlay;
      adjustElementZIndex(el, 10001);
    }
    DraggableWin.mousedown = mousedown;

    /**
     * Event handler for mouse up.
     */
    function mouseup(e, el, _data) {
      _data.down = false;
      if (!_data.overlay) {
        return;
      }

      _data.overlay.removeEventListener('mouseup', mouseup);
      _data.overlay.removeEventListener('mousedown', mousedown);
      _data.overlay.removeEventListener('mousemove', mousemove);
      _data.overlay.remove();
      adjustElementZIndex(el, _data.initialZIndex);

      setDraggerOffset(el, _data);

      // preserve the current position as property of the vue / Wegue window
      // so it can be restored when the window is re-opened
      vnode.componentInstance.$parent.top = _data.draggerOffsetTop + 'px';
      vnode.componentInstance.$parent.left = _data.draggerOffsetLeft + 'px';
    }
    DraggableWin.mouseup = mouseup;

    /**
     * Checks if left window boundary is reached.
     */
    function reachedLeft(el, _data, movingLeft) {
      return el.offsetLeft + _data.width >= window.innerWidth && !movingLeft;
    }

    /**
     * Checks if right window boundary is reached.
     */
    function reachedRight(el, _data, movingRight) {
      return el.offsetLeft <= 0 && !movingRight;
    }

    /**
     * Checks if top window boundary is reached.
     */
    function reachedTop(el, _data, movingUp) {
      return el.offsetTop <= 0 && !movingUp;
    }

    /**
     * Checks if bottom window boundary is reached.
     */
    function reachedBottom(el, _data, movingDown) {
      return el.offsetTop + _data.height >= window.innerHeight && !movingDown;
    }

    /**
     * Event handler for mouse move.
     */
    function mousemove(e, el, _data) {
      if (_data.down) {
        var movingLeft = _data.cursorPreviousX > e.clientX;
        var movingRight = _data.cursorPreviousX < e.clientX;
        var movingUp = _data.cursorPreviousY < e.clientY;
        var movingDown = _data.cursorPreviousY > e.clientY;

        if (_data.constraintToWindow && (reachedLeft(el, _data, movingLeft) || reachedRight(el, _data, movingRight))) {
          // do now allow moving outside the window horizontally
        } else {
          el.style.left = _data.draggerOffsetLeft + (e.clientX - _data.initialX) + 'px';
        }
        if (_data.constraintToWindow && (reachedTop(el, _data, movingUp) || reachedBottom(el, _data, movingDown))) {
          // do now allow moving outside the window vertically
        } else {
          el.style.top = _data.draggerOffsetTop + (e.clientY - _data.initialY) + 'px';
        }
      }
      _data.cursorPreviousX = e.clientX;
      _data.cursorPreviousY = e.clientY;
    }
    DraggableWin.mousemove = mousemove;

    /**
     * Applies the offset values of the element.
     */
    function setDraggerOffset(el, _data) {
      _data.draggerOffsetLeft = el.offsetLeft;
      _data.draggerOffsetTop = el.offsetTop;
    }
  }
};

// Make directive available globally
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive('draggable-win', DraggableWin);

/***/ }),

/***/ "N/yJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_ol_ol_css__ = __webpack_require__("ktr9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_ol_ol_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__node_modules_ol_ol_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__app_WguApp__ = __webpack_require__("y+0P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_Url__ = __webpack_require__("v9hS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

__webpack_require__("SPmS");

// try to load an optional app specific CSS file (set project-specific styles)
try {
  __webpack_require__("Op2c");
} catch (e) {}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

// Detect isEmbedded state by attribute embedded and
// make accessible for all components
// recommended by https://vuejs.org/v2/cookbook/adding-instance-properties.html
var appEl = document.querySelector('#app');
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$isEmbedded = appEl.hasAttribute('embedded');

// Detect an URL parameter for a custom app context
var appCtx = __WEBPACK_IMPORTED_MODULE_4__util_Url__["a" /* default */].getQueryParam('appCtx');
var appCtxFile = '';
if (appCtx) {
  // simple aproach to avoid path traversal
  appCtxFile = '-' + appCtx.replace(/(\.\.[/])+/g, '');
}
var opts = {};
var createApp = function createApp(appConfig) {
  // make app config accessible for all components
  __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$appConfig = appConfig;
  /* eslint-disable no-new */
  new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    vuetify: new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a(opts),
    el: '#app',
    template: '<wgu-app/>',
    components: { WguApp: __WEBPACK_IMPORTED_MODULE_3__app_WguApp__["a" /* default */] }
  });
};

// Look in the static dir for an app-specific config file.
var configFile = 'static/app-conf' + appCtxFile + '.json';
fetch(configFile).then(function (response) {
  return response.json().then(function (appConfig) {
    createApp(appConfig);
  });
}).catch(function () {
  console.error('Cannot load config file: ' + configFile);
});

/***/ }),

/***/ "NkLf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__ = __webpack_require__("DcW1");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707129f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__ = __webpack_require__("lPmp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("N/yJ")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707129f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_707129f2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Nkpt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PropertyTable__ = __webpack_require__("ZY9t");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CoordsTable__ = __webpack_require__("R3+W");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-infoclick-win',
  components: {
    'wgu-property-table': __WEBPACK_IMPORTED_MODULE_1__PropertyTable__["a" /* default */],
    'wgu-coords-table': __WEBPACK_IMPORTED_MODULE_2__CoordsTable__["a" /* default */]
  },
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    icon: { type: String, required: false, default: 'info' },
    title: { type: String, required: false, default: 'Map Click Info' },
    draggable: { type: Boolean, required: false, default: true },
    initPos: { type: Object, required: false }
  },
  data: function data() {
    return {
      show: false,
      left: this.initPos ? this.initPos.left + 'px' : '0',
      top: this.initPos ? this.initPos.top + 'px' : '0',
      attributeData: null,
      coordsData: null
    };
  },
  created: function created() {
    var me = this;
    // Listen to the ol-map-mounted event and receive the OL map instance
    __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
      // make the OL map accessible in this component
      me.map = olMap;
    });
  },

  methods: {
    toggleUi: function toggleUi() {
      this.show = !this.show;
    },
    registerMapClick: function registerMapClick(unregister) {
      var me = this;

      if (unregister === true) {
        me.map.un('singleclick', me.onMapClick);
      } else {
        me.map.on('singleclick', me.onMapClick);
      }
    },

    /**
     * Handler for 'singleclick' on the map.
     * Collects data and passes it to corresponding objects.
     *
     * @param  {ol/MapBrowserEvent} evt The OL event of 'singleclick' on the map
     */
    onMapClick: function onMapClick(evt) {
      var me = this;
      var featureLayer = me.map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
        return [feature, layer];
      });

      // collect feature attributes --> PropertyTable
      if (featureLayer) {
        var feat = featureLayer[0];
        var props = feat.getProperties();
        // do not show geometry property
        delete props.geometry;

        me.attributeData = props;
      } else {
        me.attributeData = null;
      }

      // collect click coordinate + projection --> CoordsTable
      me.coordsData = {
        coordinate: evt.coordinate,
        projection: me.map.getView().getProjection().getCode()
      };
    }
  },
  watch: {
    show: function show() {
      var me = this;
      if (this.show === true) {
        me.registerMapClick();
      } else {
        // cleanup old data
        me.attributeData = null;
        me.coordsData = null;
      }
    }
  }
});

/***/ }),

/***/ "OUzU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LayerFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_layer_Tile__ = __webpack_require__("Mdwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_source_TileWMS__ = __webpack_require__("DwLH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_source_OSM__ = __webpack_require__("WiOa");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_layer_VectorTile__ = __webpack_require__("fZPI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_source_VectorTile__ = __webpack_require__("hGhA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_format_MVT__ = __webpack_require__("fGhu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_format_GeoJSON__ = __webpack_require__("aUhy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_format_TopoJSON__ = __webpack_require__("UjZP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_format_KML__ = __webpack_require__("srNp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_format_GML2__ = __webpack_require__("aodK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_format_GML3__ = __webpack_require__("X0BE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ol_format_GML32__ = __webpack_require__("z8pl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ol_source_XYZ__ = __webpack_require__("irp0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ol_loadingstrategy__ = __webpack_require__("f2+N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__OlStyle__ = __webpack_require__("fT5P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_ol_extent__ = __webpack_require__("/LWt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_ol_proj__ = __webpack_require__("yGLh");





















/**
 * Factory, which creates OpenLayers layer instances according to a given config
 * object.
 */
var LayerFactory = {

  /**
   * Maps the format literal of the config to the corresponding OL module.
   * @type {Object}
   */
  formatMapping: {
    'MVT': __WEBPACK_IMPORTED_MODULE_6_ol_format_MVT__["a" /* default */],
    'GeoJSON': __WEBPACK_IMPORTED_MODULE_7_ol_format_GeoJSON__["a" /* default */],
    'TopoJSON': __WEBPACK_IMPORTED_MODULE_8_ol_format_TopoJSON__["a" /* default */],
    'KML': __WEBPACK_IMPORTED_MODULE_9_ol_format_KML__["a" /* default */],
    'GML2': __WEBPACK_IMPORTED_MODULE_10_ol_format_GML2__["a" /* default */],
    'GML3': __WEBPACK_IMPORTED_MODULE_11_ol_format_GML3__["a" /* default */],
    'GML32': __WEBPACK_IMPORTED_MODULE_12_ol_format_GML32__["a" /* default */]
  },

  /**
   * Maps the format literal of the config to the corresponding WFS outputFormat.
   * @type {Object}
   */
  wfsFormatMapping: {
    'GeoJSON': 'application/json',
    'GML2': 'text/xml; subtype=gml/2.1.2',
    'GML3': 'text/xml; subtype=gml/3.1.1',
    'GML32': 'text/xml; subtype=gml/3.2'
  },

  /**
   * Returns an OpenLayers layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @param  {ol/Map} olMap  Optional OL map we work on
   * @return {ol/layer/Base} OL layer instance
   */
  getInstance: function getInstance(lConf, olMap) {
    // apply LID (Layer ID) if not existent
    if (!lConf.lid) {
      // Make a unique layerId from Layer name and URL so contexts
      // like permalinks can be reapplied.
      lConf.lid = btoa(lConf.url + lConf.name).substr(0, 6);
    }

    // create correct layer type
    if (lConf.type === 'WMS') {
      return this.createWmsLayer(lConf);
    } else if (lConf.type === 'WFS') {
      return this.createWfsLayer(lConf, olMap);
    } else if (lConf.type === 'XYZ') {
      return this.createXyzLayer(lConf);
    } else if (lConf.type === 'OSM') {
      return this.createOsmLayer(lConf);
    } else if (lConf.type === 'VECTOR') {
      return this.createVectorLayer(lConf);
    } else if (lConf.type === 'VECTORTILE') {
      return this.createVectorTileLayer(lConf);
    } else {
      return null;
    }
  },


  /**
   * Returns an OpenLayers WMS layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL WMS layer instance
   */
  createWmsLayer: function createWmsLayer(lConf) {
    var layer = new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Tile__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      displayInLayerList: lConf.displayInLayerList,
      extent: lConf.extent,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_2_ol_source_TileWMS__["a" /* default */]({
        url: lConf.url,
        params: {
          'LAYERS': lConf.layers,
          'TILED': lConf.tiled
        },
        serverType: lConf.serverType,
        attributions: lConf.attributions,
        tileGrid: lConf.tileGrid,
        projection: lConf.projection
      })
    });

    return layer;
  },


  /**
   * Returns an OpenLayers WFS layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @param  {ol/Map} olMap  The OpenLayers map we work on
   * @return {ol.layer.Tile} OL WFS layer instance
   */
  createWfsLayer: function createWfsLayer(lConf, olMap) {
    var mapSrs = olMap.getView().getProjection().getCode();
    // set a default projection if not set in config
    if (!lConf.projection) {
      lConf.projection = mapSrs;
    }
    // set a default WFS version if not set in config
    if (!lConf.version) {
      lConf.version = '1.1.0';
    }
    if (!lConf.format) {
      lConf.format = 'GML3';
    }

    // detect the WFS output format
    var outputFormat = this.wfsFormatMapping[lConf.format];

    // overwrite format options, so they fit to the SRS (map vs. data)
    if (mapSrs !== lConf.projection) {
      lConf.formatConfig.dataProjection = lConf.projection;
      lConf.formatConfig.featureProjection = mapSrs;
    }

    var vectorSource = new __WEBPACK_IMPORTED_MODULE_14_ol_source_Vector__["a" /* default */]({
      format: new this.formatMapping[lConf.format](lConf.formatConfig),
      loader: function loader(extent) {
        // assemble WFS GetFeature request
        var wfsRequest = lConf.url + '?service=WFS&' + 'version=' + lConf.version + '&request=GetFeature&' + 'typename=' + lConf.typeName + '&' + 'outputFormat=' + outputFormat + '&srsname=' + lConf.projection;

        // add WFS version dependent feature limitation
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(lConf.maxFeatures))) {
          if (lConf.version.startsWith('1.')) {
            wfsRequest += '&maxFeatures=' + lConf.maxFeatures;
          } else {
            wfsRequest += '&count=' + lConf.maxFeatures;
          }
        }
        // add bbox filter
        if (lConf.loadOnlyVisible !== false) {
          if (mapSrs !== lConf.projection) {
            extent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_ol_extent__["h" /* applyTransform */])(extent, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_ol_proj__["h" /* getTransform */])(mapSrs, lConf.projection));
          }
          wfsRequest += '&bbox=' + extent.join(',') + ',' + lConf.projection + '';
        }

        // load data from WFS, parse and add to vector source
        fetch(wfsRequest).then(function (response) {
          return response.text();
        }).then(function (responseText) {
          var feats = vectorSource.getFormat().readFeatures(responseText);
          vectorSource.addFeatures(feats);
        });
      },
      strategy: lConf.loadOnlyVisible !== false ? __WEBPACK_IMPORTED_MODULE_16_ol_loadingstrategy__["b" /* bbox */] : undefined,
      attributions: lConf.attributions
    });

    var vector = new __WEBPACK_IMPORTED_MODULE_13_ol_layer_Vector__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      displayInLayerList: lConf.displayInLayerList,
      extent: lConf.extent,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: vectorSource,
      style: __WEBPACK_IMPORTED_MODULE_17__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style)
    });

    return vector;
  },

  /**
   * Returns an XYZ based tile layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL XYZ layer instance
   */
  createXyzLayer: function createXyzLayer(lConf) {
    var xyzLayer = new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Tile__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      displayInLayerList: lConf.displayInLayerList,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_15_ol_source_XYZ__["a" /* default */]({
        url: lConf.url,
        attributions: lConf.attributions,
        tileGrid: lConf.tileGrid,
        projection: lConf.projection
      })
    });

    return xyzLayer;
  },


  /**
   * Returns an OpenLayers OSM layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Tile} OL OSM layer instance
   */
  createOsmLayer: function createOsmLayer(lConf) {
    var layer = new __WEBPACK_IMPORTED_MODULE_1_ol_layer_Tile__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      displayInLayerList: lConf.displayInLayerList,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_3_ol_source_OSM__["b" /* default */]()
    });

    return layer;
  },


  /**
   * Returns an OpenLayers vector layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.Vector} OL vector layer instance
   */
  createVectorLayer: function createVectorLayer(lConf) {
    var vectorLayer = new __WEBPACK_IMPORTED_MODULE_13_ol_layer_Vector__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      displayInLayerList: lConf.displayInLayerList,
      extent: lConf.extent,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_14_ol_source_Vector__["a" /* default */]({
        url: lConf.url,
        format: new this.formatMapping[lConf.format](lConf.formatConfig),
        attributions: lConf.attributions
      }),
      style: __WEBPACK_IMPORTED_MODULE_17__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style),
      hoverable: lConf.hoverable,
      hoverAttribute: lConf.hoverAttribute
    });

    return vectorLayer;
  },


  /**
   * Returns an OpenLayers vector tile layer instance due to given config.
   *
   * @param  {Object} lConf  Layer config object
   * @return {ol.layer.VectorTile} OL vector tile layer instance
   */
  createVectorTileLayer: function createVectorTileLayer(lConf) {
    var vtLayer = new __WEBPACK_IMPORTED_MODULE_4_ol_layer_VectorTile__["a" /* default */]({
      name: lConf.name,
      lid: lConf.lid,
      displayInLayerList: lConf.displayInLayerList,
      visible: lConf.visible,
      opacity: lConf.opacity,
      source: new __WEBPACK_IMPORTED_MODULE_5_ol_source_VectorTile__["a" /* default */]({
        url: lConf.url,
        format: new this.formatMapping[lConf.format](),
        attributions: lConf.attributions,
        tileGrid: lConf.tileGrid,
        projection: lConf.projection
      }),
      style: __WEBPACK_IMPORTED_MODULE_17__OlStyle__["a" /* OlStyleFactory */].getInstance(lConf.style),
      hoverable: lConf.hoverable,
      hoverAttribute: lConf.hoverAttribute
    });

    return vtLayer;
  }
};

/***/ }),

/***/ "Op2c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "P5f+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-logo',
  data: function data() {
    return {
      logoSrc: this.$appConfig.logo,
      logoSize: this.$appConfig.logoSize,
      logoWidth: this.$appConfig.logoWidth,
      logoHeight: this.$appConfig.logoHeight
    };
  },
  created: function created() {
    // for backwards compat we use logoSize if width and height are missing
    if (this.logoSize && !this.logoWidth && !this.logoHeight) {
      this.logoWidth = this.logoSize;
      this.logoHeight = this.logoSize;
    }
  }
});

/***/ }),

/***/ "Q9Yo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Startscreen_vue__ = __webpack_require__("uACE");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31de38d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Startscreen_vue__ = __webpack_require__("7bKC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("TGWl")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-31de38d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Startscreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31de38d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Startscreen_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_31de38d4_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Startscreen_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R3+W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoordsTable_vue__ = __webpack_require__("L1xf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b02470a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__ = __webpack_require__("j++n");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("6ANF")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CoordsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b02470a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b02470a6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CoordsTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "R6sm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RAvm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_ol_source___ = __webpack_require__("8cSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_layer_Group__ = __webpack_require__("0uY1");
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-maploading-status',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__["a" /* Mapable */]],
  props: {
    color: { type: String, default: 'red darken-3' }
  },
  data: function data() {
    return {
      loading: 0,
      visible: false
    };
  },

  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     * and registers the current map layers.
     */
    onMapBound: function onMapBound() {
      var me = this;
      me.registerLayers(me.map.getLayerGroup());
    },


    /**
     * Registers the needed events for the passed layer and takes care
     * of layer groups by calling itself recursively.
     *
     * @param  {ol/layer/Base | ol/layer/Group} layer Layer or group to register
     */
    registerLayers: function registerLayers(layer) {
      var me = this;

      if (layer instanceof __WEBPACK_IMPORTED_MODULE_2_ol_layer_Group__["a" /* default */]) {
        // call ourself recursively
        var layers = layer.getLayers();
        layers.forEach(function (child) {
          me.registerLayers(child);
        });
        // handle future changes to this group or stop doing so
        layers.on('add', me.onLayerAddedToGroup, me);
        layers.on('remove', me.onLayerRemovedFromGroup, me);
      } else {
        var source = layer.getSource();
        me.bindLoadHandlers(source, true);
        // reacting on a changed source in a layer
        layer.on('change:source', function (evt) {
          me.bindLoadHandlers(evt.target.getSource(), true);
          me.bindLoadHandlers(evt.oldValue, false);
        });
      }
    },


    /**
     * Registers needed events for the passed source and takes care
     * of sources which do not naturally support load events (`vector`-sources).
     *
     * @param  {ol/source/Source} source The layer source to register
     */
    bindLoadHandlers: function bindLoadHandlers(source, register) {
      var me = this;
      var eventPrefix = '';
      var method = register ? 'on' : 'un';

      if (source instanceof __WEBPACK_IMPORTED_MODULE_1_ol_source___["a" /* Image */]) {
        // includes ImageWms, also e.g. ImageArcGISRest, OSM …
        eventPrefix = 'image';
      } else if (source instanceof __WEBPACK_IMPORTED_MODULE_1_ol_source___["b" /* TileImage */]) {
        // includes TileWMS, Bing and more
        eventPrefix = 'tile';
      } else if (source instanceof __WEBPACK_IMPORTED_MODULE_1_ol_source___["c" /* Vector */]) {
        if (source instanceof __WEBPACK_IMPORTED_MODULE_1_ol_source___["d" /* Cluster */]) {
          source = source.getSource();
        }
        eventPrefix = 'vector';
      }

      if (eventPrefix) {
        source[method](eventPrefix + 'loadstart', me.incrementLoading, me);
        source[method](eventPrefix + 'loadend', me.decrementLoading, me);
        source[method](eventPrefix + 'loaderror', me.decrementLoading, me);
      }
    },


    /**
     * Called whenever loading of a layer starts.
     * This will increment the internal counter and show this loading indicator.
     */
    incrementLoading: function incrementLoading() {
      var me = this;
      me.loading++;
      me.visible = true;
    },


    /**
     * Called whenever loading stops or errors.
     * This will decrement the internal counter and if nothing is currently
     * loading the counter is reset and the loading indicator is hidden.
     */
    decrementLoading: function decrementLoading() {
      var me = this;
      me.loading--;

      if (me.loading <= 0) {
        me.visible = false;
        me.resetLoading();
      }
    },


    /**
     * Helper method to reset the internal loading counter.
     */
    resetLoading: function resetLoading() {
      this.loading = 0;
    },


    /**
     * Takes care of added layers to any `ol/layer/Group`. These need to get
     * registered to the appropriate handlers.
     *
     * @param {ol/events/Event} evt The add event of the `ol/layer/Group`.
     */
    onLayerAddedToGroup: function onLayerAddedToGroup(evt) {
      this.registerLayers(evt.element);
    },

    /**
     * Takes care of removed layers to any `ol/layer/Group`. These need to get
     * unregistered from the appropriate handlers.
     *
     * @param {ol/events/Event} evt The remove event of the `ol/layer/Group`.
     */
    onLayerRemovedFromGroup: function onLayerRemovedFromGroup(evt) {
      this.registerLayers(evt.element);
    }
  }
});

/***/ }),

/***/ "S36s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__("JwL6");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae9bc104_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__("yRk2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("kDS9")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ae9bc104"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae9bc104_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ae9bc104_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SPmS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T3i0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WikipediaApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);



var WikipediaApi = {
  /**
   * Loads an Wikipedia article for the given query string.
   *
   * @param  {String} queryString Query string to search article by
   * @return {Promise}            Promise resolving to the API response JSON
   */
  loadArticle: function loadArticle(queryString) {
    var url = new URL('https://de.wikipedia.org/w/api.php?');
    var params = {
      format: 'json',
      action: 'query',
      prop: 'extracts|pageimages|images',
      exintro: '',
      explaintext: '',
      // prop: 'pageimages|extracts|images',
      titles: queryString,
      origin: '*'
    };
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
      return url.searchParams.append(key, params[key]);
    });

    var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      fetch(url).then(function (resp) {
        return resp.json();
      }).then(function (respJson) {
        if (respJson.query.pages && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(respJson.query.pages).length > 0) {
          resolve(respJson.query.pages);
        } else {
          reject(Error('No data (articles) found'));
        }
      });
    });

    return promise;
  },


  /**
   * Loads an Wikipedia image with the given image name.
   *
   * @param  {String} imageName Name of the image file
   * @return {Promise}          Promise resolving to the API response JSON
   */
  loadImage: function loadImage(imageName) {
    var url = new URL('https://de.wikipedia.org/w/api.php?');
    var params = {
      format: 'json',
      action: 'query',
      titles: 'Image:' + imageName,
      prop: 'imageinfo',
      iiprop: 'url',
      origin: '*'
    };
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
      return url.searchParams.append(key, params[key]);
    });

    var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      fetch(url).then(function (resp) {
        return resp.json();
      }).then(function (respJson) {
        if (respJson.query.pages && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(respJson.query.pages).length > 0) {
          resolve(respJson.query.pages);
        } else {
          reject(Error('No data (images) found'));
        }
      });
    });

    return promise;
  },


  /**
   * Returns a radom image of a Wikipedia page described in its JSON
   *
   * @param  {Object} wikiPage JSON of a Wikipedia page
   * @return {String}          Filename
   */
  getRandomImageName: function getRandomImageName(wikiPage) {
    var imgs = wikiPage.images;
    if (!imgs) {
      return null;
    }
    var randomImage = imgs[Math.floor(Math.random() * imgs.length)];
    var cleanedName = randomImage.title.replace('Datei:', '');

    var safeCnt = 0;
    while (this.isGenericWikipediaImage(cleanedName) && safeCnt < imgs.length) {
      randomImage = imgs[Math.floor(Math.random() * imgs.length)];
      cleanedName = randomImage.title.replace('Datei:', '');

      safeCnt++;
    }

    if (safeCnt === imgs.length) {
      return null;
    }

    return cleanedName;
  },


  /**
   * Detects if the given image name belongs to a generic wikipedia image, which
   * is used in several articles (wo/ a meaning for the article topic).
   *
   * @param  {String}  imageName The image name
   * @return {Boolean}           Generic image yes/no (true/false)
   */
  isGenericWikipediaImage: function isGenericWikipediaImage(imageName) {
    var genericImgs = ['_gray.svg', 'icon', 'Commons-logo.svg', 'Ambox', 'Text_document_with_red_question_mark.svg', 'Question_book-new.svg', 'Canadese_kano', 'Wiki_letter_', 'Edit-clear.svg', 'WPanthroponymy', 'Compass_rose_pale', 'Us-actor.svg', 'voting_box', 'Crystal_', 'transportation_inv', 'arrow.svg', 'Quill_and_ink-US.svg', 'Decrease2.svg', 'Rating-', 'template', 'Nuvola_apps_', 'Mergefrom.svg', 'Portal-', 'Translation_to_', 'School.svg', 'arrow', 'Symbol_', 'stub', 'Unbalanced_scales.svg', '-logo.', 'P_vip.svg', 'Books-aj.svg_aj_ashton_01.svg', 'Film', 'Gnome-', 'cap.svg', 'Missing', 'silhouette', 'Star_empty.svg', 'Music_film_clapperboard.svg', 'IPA_Unicode', 'symbol', '_highlighting_', 'pictogram', 'Pictogram_voting_info.svg', 'Red_pog.svg', '_medal_with_cup', '_balloon', 'Feature', 'Aiga_', 'Disambig', 'Reddot', 'Germany_adm_location_map', 'Germany_adm_location_map.svg'];

    var isGeneric = false;
    for (var i = 0; i < genericImgs.length; i++) {
      // console.log(genericImgs[i]);
      if (imageName.indexOf(genericImgs[i]) !== -1) {
        isGeneric = true;
      }
    }

    return isGeneric;
  }
};

/***/ }),

/***/ "TGWl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TooU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measure-type-chooser',
  props: {
    measureType: { type: String, default: 'distance' }
  },
  data: function data() {
    return {
      measureTypeData: this.measureType
    };
  },

  watch: {
    // listen to changed measurement type and forward to parent component
    measureTypeData: function measureTypeData(newVal, oldVal) {
      this.$emit('wgu-measuretype-change', newVal, oldVal);
    }
  }
});

/***/ }),

/***/ "Tvpq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UAgb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__ = __webpack_require__("bv4e");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e80bee_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__ = __webpack_require__("dwOX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("avt2")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e80bee_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_48e80bee_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UZyY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UdpQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_Map__ = __webpack_require__("trid");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_View__ = __webpack_require__("Lfyu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_control_Attribution__ = __webpack_require__("bAyG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_control_Zoom__ = __webpack_require__("Lmaf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_interaction_Select__ = __webpack_require__("gsgi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_interaction__ = __webpack_require__("TDso");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_control_Rotate__ = __webpack_require__("lZ2e");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_ol_proj_Projection__ = __webpack_require__("7rnj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_ol_tilegrid_TileGrid__ = __webpack_require__("clnH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_ol_proj_proj4__ = __webpack_require__("4Asb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_ol_Overlay__ = __webpack_require__("kZ1N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_ol_format__ = __webpack_require__("3Zsm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_ol_layer__ = __webpack_require__("ItK/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_ol_source__ = __webpack_require__("8cSO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_proj4__ = __webpack_require__("nvAS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__WguEventBus_js__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__factory_Layer_js__ = __webpack_require__("OUzU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__util_Color__ = __webpack_require__("nF/d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__util_Layer__ = __webpack_require__("fIFi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PermalinkController__ = __webpack_require__("1l2W");


//
//


















// import the app-wide EventBus






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-map',
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    collapsibleAttribution: { type: Boolean, default: false },
    rotateableMap: { type: Boolean, required: false, default: false }
  },
  data: function data() {
    return {
      zoom: this.$appConfig.mapZoom,
      center: this.$appConfig.mapCenter,
      projection: this.$appConfig.mapProjection,
      projectionObj: null,
      projectionDefs: this.$appConfig.projectionDefs,
      tileGridDefs: this.$appConfig.tileGridDefs || {},
      tileGrids: {},
      permalink: this.$appConfig.permalink,
      mapGeodataDragDop: this.$appConfig.mapGeodataDragDop,
      // mapping format string to OL module / class
      formatMapping: {
        GPX: __WEBPACK_IMPORTED_MODULE_14_ol_format__["a" /* GPX */],
        GeoJSON: __WEBPACK_IMPORTED_MODULE_14_ol_format__["b" /* GeoJSON */],
        IGC: __WEBPACK_IMPORTED_MODULE_14_ol_format__["c" /* IGC */],
        KML: __WEBPACK_IMPORTED_MODULE_14_ol_format__["d" /* KML */],
        TopoJSON: __WEBPACK_IMPORTED_MODULE_14_ol_format__["e" /* TopoJSON */]
      },
      dragDropLayerCreated: false
    };
  },
  mounted: function mounted() {
    var me = this;
    // Make the OL map accessible for Mapable mixin even 'ol-map-mounted' has
    // already been fired. Don not use directly in cmps, use Mapable instead.
    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$map = me.map;
    // Send the event 'ol-map-mounted' with the OL map as payload
    __WEBPACK_IMPORTED_MODULE_18__WguEventBus_js__["a" /* WguEventBus */].$emit('ol-map-mounted', me.map);

    // resize the map, so it fits to parent
    window.setTimeout(function () {
      me.map.setTarget(document.getElementById('ol-map-container'));
      me.map.updateSize();

      // adjust the bg color of the OL buttons (like zoom, rotate north, ...)
      me.setOlButtonColor();

      // initialize map hover functionality
      me.setupMapHover();
    }, 200);
  },
  created: function created() {
    var _this = this;

    // make map rotateable according to property
    var interactions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_ol_interaction__["a" /* defaults */])({
      altShiftDragRotate: this.rotateableMap,
      pinchRotate: this.rotateableMap
    });

    // add geodata drag-drop support according to config
    if (this.mapGeodataDragDop) {
      var dragAndDropInteraction = this.setupGeodataDragDrop();
      interactions.push(dragAndDropInteraction);
    }

    var controls = [new __WEBPACK_IMPORTED_MODULE_6_ol_control_Zoom__["a" /* default */](), new __WEBPACK_IMPORTED_MODULE_5_ol_control_Attribution__["a" /* default */]({
      collapsible: this.collapsibleAttribution
    })];
    // add a button control to reset rotation to 0, if map is rotateable
    if (this.rotateableMap) {
      controls.push(new __WEBPACK_IMPORTED_MODULE_9_ol_control_Rotate__["a" /* default */]());
    }

    // Optional projection (EPSG) definitions for Proj4
    if (this.projectionDefs) {
      // Add all (array of array)
      __WEBPACK_IMPORTED_MODULE_17_proj4__["a" /* default */].defs(this.projectionDefs);
      // Register with OpenLayers
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_ol_proj_proj4__["a" /* register */])(__WEBPACK_IMPORTED_MODULE_17_proj4__["a" /* default */]);
    }

    // Projection for Map, default is Web Mercator
    if (!this.projection) {
      this.projection = { code: 'EPSG:3857', units: 'm' };
    }

    var projection = new __WEBPACK_IMPORTED_MODULE_10_ol_proj_Projection__["a" /* default */](this.projection);

    // Optional TileGrid definitions by name, for ref in Layers
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.tileGridDefs).map(function (name) {
      _this.tileGrids[name] = new __WEBPACK_IMPORTED_MODULE_11_ol_tilegrid_TileGrid__["a" /* default */](_this.tileGridDefs[name]);
    });

    this.map = new __WEBPACK_IMPORTED_MODULE_3_ol_Map__["a" /* default */]({
      layers: [],
      controls: controls,
      interactions: interactions,
      view: new __WEBPACK_IMPORTED_MODULE_4_ol_View__["a" /* default */]({
        center: this.center,
        zoom: this.zoom,
        projection: projection
      })
    });

    // create layers from config and add them to map
    var layers = this.createLayers();
    this.map.getLayers().extend(layers);

    if (this.$appConfig.permalink) {
      this.permalinkController = this.createPermalinkController();
      this.map.set('permalinkcontroller', this.permalinkController, true);
      this.permalinkController.apply();
      this.permalinkController.setup();
    }
  },


  methods: {
    /**
     * Creates the OL layers due to the "mapLayers" array in app config.
     * @return {ol.layer.Base[]} Array of OL layer instances
     */
    createLayers: function createLayers() {
      var me = this;
      var layers = [];
      var appConfig = this.$appConfig;
      var mapLayersConfig = appConfig.mapLayers || [];
      mapLayersConfig.reverse().forEach(function (lConf) {
        // Some Layers may require a TileGrid object
        lConf.tileGrid = lConf.tileGridRef ? me.tileGrids[lConf.tileGridRef] : null;

        var layer = __WEBPACK_IMPORTED_MODULE_19__factory_Layer_js__["a" /* LayerFactory */].getInstance(lConf, me.map);
        layers.push(layer);

        // if layer is selectable register a select interaction
        if (lConf.selectable) {
          var selectClick = new __WEBPACK_IMPORTED_MODULE_7_ol_interaction_Select__["a" /* default */]({
            layers: [layer]
          });
          // forward an event if feature selection changes
          selectClick.on('select', function (evt) {
            // TODO use identifier for layer (once its implemented)
            __WEBPACK_IMPORTED_MODULE_18__WguEventBus_js__["a" /* WguEventBus */].$emit('map-selectionchange', layer.get('lid'), evt.selected, evt.deselected);
          });
          // register/activate interaction on map
          me.map.addInteraction(selectClick);
        }
      });

      return layers;
    },


    /**
     * Creates a PermalinkController, override in subclass for specializations.
     *
     * @return {PermalinkController} PermalinkController instance.
     */
    createPermalinkController: function createPermalinkController() {
      return new __WEBPACK_IMPORTED_MODULE_22__PermalinkController__["a" /* default */](this.map, this.$appConfig.permalink);
    },


    /**
     * Sets the background color of the OL buttons to the color property.
     */
    setOlButtonColor: function setOlButtonColor() {
      var me = this;

      if (__WEBPACK_IMPORTED_MODULE_20__util_Color__["a" /* default */].isCssColor(me.color)) {
        // directly apply the given CSS color
        if (document.querySelector('.ol-zoom')) {
          document.querySelector('.ol-zoom .ol-zoom-in').style.backgroundColor = me.color;
          document.querySelector('.ol-zoom .ol-zoom-out').style.backgroundColor = me.color;
        }
        if (document.querySelector('.ol-rotate')) {
          document.querySelector('.ol-rotate .ol-rotate-reset').style.backgroundColor = me.color;
        }
      } else {
        // apply vuetify color by transforming the color to the corresponding
        // CSS class (see https://vuetifyjs.com/en/framework/colors)
        var _me$color$toString$tr = me.color.toString().trim().split(' ', 2),
            _me$color$toString$tr2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_me$color$toString$tr, 2),
            colorName = _me$color$toString$tr2[0],
            colorModifier = _me$color$toString$tr2[1];

        if (document.querySelector('.ol-zoom')) {
          document.querySelector('.ol-zoom .ol-zoom-in').classList.add(colorName);
          document.querySelector('.ol-zoom .ol-zoom-in').classList.add(colorModifier);
          document.querySelector('.ol-zoom .ol-zoom-out').classList.add(colorName);
          document.querySelector('.ol-zoom .ol-zoom-out').classList.add(colorModifier);
        }
        if (document.querySelector('.ol-rotate')) {
          document.querySelector('.ol-rotate .ol-rotate-reset').classList.add(colorName);
          document.querySelector('.ol-rotate .ol-rotate-reset').classList.add(colorModifier);
        }
      }
    },

    /**
     * Initializes the map hover functionality:
     * Adds a little tooltip like DOM element, wrapped as OL Overlay to the
     * map.
     * Registers a 'pointermove' event on the map and shows the layer's
     * 'hoverAttribute' if the layer is configured as 'hoverable'
     */
    setupMapHover: function setupMapHover() {
      var me = this;
      var map = me.map;
      var overlayEl = void 0;

      // create a span to show map tooltip
      overlayEl = document.createElement('span');
      overlayEl.classList.add('wgu-hover-tooltiptext');
      map.getTarget().append(overlayEl);

      me.overlayEl = overlayEl;

      // wrap the tooltip span in a OL overlay and add it to map
      me.overlay = new __WEBPACK_IMPORTED_MODULE_13_ol_Overlay__["a" /* default */]({
        element: overlayEl,
        autoPan: true,
        autoPanAnimation: {
          duration: 250
        }
      });
      map.addOverlay(me.overlay);

      // show tooltip if a hoverable feature gets hit with the mouse
      map.on('pointermove', me.onPointerMove, me);
    },

    /**
     * Shows the hover tooltip on the map if an appropriate feature of a
     * 'hoverable' layer was hit with the mouse.
     *
     * @param  {Object} event The OL event for pointermove
     */
    onPointerMove: function onPointerMove(event) {
      var me = this;
      var map = me.map;
      var overlayEl = me.overlayEl;
      var hoverAttr = void 0;
      var features = map.getFeaturesAtPixel(event.pixel, { layerFilter: function layerFilter(layer) {
          if (layer.get('hoverable')) {
            hoverAttr = layer.get('hoverAttribute');
          }
          return layer.get('hoverable');
        } });
      if (!features || features.length === 0 || !hoverAttr) {
        hoverAttr = null;
        overlayEl.innerHTML = null;
        me.overlay.setPosition(undefined);
        return;
      }
      var feature = features[0];
      var attr = feature.get(hoverAttr);
      overlayEl.innerHTML = attr;
      me.overlay.setPosition(event.coordinate);
    },

    /**
     * Initializes the geodata drag-drop functionality:
     * Adds the ol/interaction/DragAndDrop to the map and draws the dropped
     * features in a vector layer
     */
    setupGeodataDragDrop: function setupGeodataDragDrop() {
      var _this2 = this;

      var mapDdConf = this.mapGeodataDragDop;
      var formats = mapDdConf.formats.filter(function (formatStr) {
        return _this2.formatMapping[formatStr];
      }).map(function (fs) {
        return _this2.formatMapping[fs];
      });

      var dragAndDropInteraction = new __WEBPACK_IMPORTED_MODULE_8_ol_interaction__["b" /* DragAndDrop */]({
        formatConstructors: formats
      });

      dragAndDropInteraction.on('addfeatures', function (event) {
        var ddSource = void 0;

        if (mapDdConf.replaceData !== false) {
          if (!_this2.dragDropLayerCreated) {
            _this2.createDragDropLayer(mapDdConf);
            _this2.dragDropLayerCreated = true;
          }

          // replace existing geodata with the newly dropped data set
          var ddLayer = __WEBPACK_IMPORTED_MODULE_21__util_Layer__["a" /* default */].getLayersBy('wegueDragDropLayer', true, _this2.map)[0];
          ddSource = ddLayer.getSource();
          ddSource.clear();
        } else {
          // add new layer for each dropped data set
          var newDdLayer = _this2.createDragDropLayer(mapDdConf);
          ddSource = newDdLayer.getSource();
        }

        ddSource.addFeatures(event.features);

        if (mapDdConf.zoomToData === true) {
          _this2.map.getView().fit(ddSource.getExtent());
        }
      }, this);

      return dragAndDropInteraction;
    },


    /**
     * Creates the vector layer for showing drag/drop geodata on the map.
     *
     * @param {Object} mapDdConf the config object for this functionality
     */
    createDragDropLayer: function createDragDropLayer(mapDdConf) {
      var vectorSource = new __WEBPACK_IMPORTED_MODULE_16_ol_source__["c" /* Vector */]({});
      var vectorLayer = new __WEBPACK_IMPORTED_MODULE_15_ol_layer__["a" /* Vector */]({
        // random unique layer ID
        lid: 'wegue-drag-drop-' + (Math.random() * 1000000).toFixed(0),
        name: mapDdConf.layerName || 'Drag/Drop Data',
        wegueDragDropLayer: true,
        source: vectorSource,
        displayInLayerList: mapDdConf.displayInLayerList
      });
      this.map.addLayer(vectorLayer);

      return vectorLayer;
    }
  }

});

/***/ }),

/***/ "UkhJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpWin_vue__ = __webpack_require__("7OTJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_720198e8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__ = __webpack_require__("AdsX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("Tvpq")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HelpWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_720198e8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_720198e8_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HelpWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VLBH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__ = __webpack_require__("WFjz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Layer__ = __webpack_require__("fIFi");
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlist',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__["a" /* Mapable */]],
  props: {},
  data: function data() {
    return {
      layerItems: [],
      changeVisByClickUpdate: false
    };
  },

  methods: {
    /**
     * This function is executed, after the map is bound (see mixins/Mapable)
     */
    onMapBound: function onMapBound() {
      var me = this;
      me.createLayerItems();

      // react on added / removed layers
      me.map.getLayers().on('change:length', function (evt) {
        me.createLayerItems();
      });
    },

    /**
     * Creates the layer items from the OpenLayers map.
     */
    createLayerItems: function createLayerItems() {
      var me = this;
      // go over all layers from the map and list them up
      var layers = this.map.getLayers();
      // clone to only reverse the order for the list
      var layerArrClone = layers.getArray().slice(0);
      layers = layerArrClone.reverse();

      var layerItems = [];
      layers.forEach(function (layer) {
        // skip if layer should not be listed
        if (layer.get('displayInLayerList') === false) {
          return;
        }
        layerItems.push({
          title: layer.get('name'),
          lid: layer.get('lid'),
          visible: layer.getVisible()
        });

        // synchronize visibility with UI when changed programatically
        layer.on('change:visible', me.onOlLayerVizChange);
      });

      me.layerItems = layerItems;
    },


    /**
     * Handles the 'change:visible' event of the layer in order to
     * apply the current visibility state to the corresponding checkbox in
     * case the 'change:visible' wasn't triggered by click.
     *
     * @param  {ol/Object.ObjectEvent} evt The OL event of 'change:visible'
     */
    onOlLayerVizChange: function onOlLayerVizChange(evt) {
      var me = this;
      if (!me.changeVisByClickUpdate) {
        me.layerItems.forEach(function (layerItem, idx) {
          if (layerItem.lid === evt.target.get('lid')) {
            // execute click handler to change visibility
            me.onItemClick(null, layerItem);
          }
        });
      }
    },


    /**
     * Handler for click on item in layer list:
     * Toggles the corresponding visibility and calls this.layerVizChanged.
     *
     * @param  {Object} ect       Original vue click event
     * @param  {Object} layerItem Layer item data object
     */
    onItemClick: function onItemClick(evt, layerItem) {
      var me = this;
      layerItem.visible = !layerItem.visible;

      me.changeVisByClickUpdate = true;
      this.layerVizChanged();
      me.changeVisByClickUpdate = false;
    },


    /**
     * Handles the 'change' event of the visibility checkboxes in order to
     * apply the current visibility state in 'data' to the OL layers.
     */
    layerVizChanged: function layerVizChanged() {
      var me = this;

      me.layerItems.forEach(function (layerItem, idx) {
        var layer = __WEBPACK_IMPORTED_MODULE_1__util_Layer__["a" /* default */].getLayerByLid(layerItem.lid, me.map);
        if (layer) {
          layer.setVisible(layerItem.visible);
        }
      });
    }
  }
});

/***/ }),

/***/ "VT4C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__("Zrlr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__("wxAW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_interaction_Draw__ = __webpack_require__("aUJj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_ol_Observable_js__ = __webpack_require__("nxYM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_ol_source_Vector__ = __webpack_require__("WMwB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_ol_layer_Vector__ = __webpack_require__("Umvz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_ol_style_Style__ = __webpack_require__("Mjwz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_ol_style_Stroke__ = __webpack_require__("00zS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_ol_style_Circle__ = __webpack_require__("uli1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_ol_style_Fill__ = __webpack_require__("lUmj");












/**
 * Class holding the OpenLayers related logic for the measure tool.
 */

var OlMeasureController = function () {
  function OlMeasureController(olMap, measureConf) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, OlMeasureController);

    this.map = null;

    this.map = olMap;
    this.measureConf = measureConf || {};
  }

  /**
   * Creates a vector layer for the measurement results and adds it to the
   * map.
   */

  /* the OL map we want to measure on */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(OlMeasureController, [{
    key: 'createMeasureLayer',
    value: function createMeasureLayer() {
      var me = this;
      var measureConf = me.measureConf;
      // create a vector layer to
      var source = new __WEBPACK_IMPORTED_MODULE_4_ol_source_Vector__["a" /* default */]();
      var vector = new __WEBPACK_IMPORTED_MODULE_5_ol_layer_Vector__["a" /* default */]({
        name: 'Measure Layer',
        displayInLayerList: false,
        source: source,
        style: new __WEBPACK_IMPORTED_MODULE_6_ol_style_Style__["a" /* default */]({
          fill: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Fill__["a" /* default */]({
            color: measureConf.fillColor || 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new __WEBPACK_IMPORTED_MODULE_7_ol_style_Stroke__["a" /* default */]({
            color: measureConf.strokeColor || 'rgba(0, 0, 0, 0.5)',
            width: 2
          })
        })
      });

      me.map.addLayer(vector);

      // make vector source available as member
      me.source = source;
    }

    /**
     * Creates and adds the necessary draw interaction and adds it to the map.
     */

  }, {
    key: 'addInteraction',
    value: function addInteraction(measureType, mapClickCb) {
      var me = this;
      var measureConf = me.measureConf;
      // cleanup possible old draw interaction
      if (me.draw) {
        me.removeInteraction();
      }

      var type = measureType === 'area' ? 'Polygon' : 'LineString';
      var draw = new __WEBPACK_IMPORTED_MODULE_2_ol_interaction_Draw__["a" /* default */]({
        source: me.source,
        type: type,
        style: new __WEBPACK_IMPORTED_MODULE_6_ol_style_Style__["a" /* default */]({
          fill: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Fill__["a" /* default */]({
            color: measureConf.sketchFillColor || 'rgba(255, 255, 255, 0.2)'
          }),
          stroke: new __WEBPACK_IMPORTED_MODULE_7_ol_style_Stroke__["a" /* default */]({
            color: measureConf.sketchStrokeColor || 'rgba(0, 0, 0, 0.5)',
            lineDash: [10, 10],
            width: 2
          }),
          image: new __WEBPACK_IMPORTED_MODULE_8_ol_style_Circle__["a" /* default */]({
            radius: 5,
            stroke: new __WEBPACK_IMPORTED_MODULE_7_ol_style_Stroke__["a" /* default */]({
              color: measureConf.sketchVertexStrokeColor || 'rgba(0, 0, 0, 0.7)'
            }),
            fill: new __WEBPACK_IMPORTED_MODULE_9_ol_style_Fill__["a" /* default */]({
              color: measureConf.sketchVertexFillColor || 'rgba(255, 255, 255, 0.2)'
            })
          })
        })
      });
      me.map.addInteraction(draw);

      var listener;
      var sketch;
      draw.on('drawstart', function (evt) {
        // clear old measure features
        me.source.clear();
        // preserve sketch
        sketch = evt.feature;

        listener = me.map.on('click', function (evt) {
          var geom = sketch.getGeometry();
          // execute given callback
          mapClickCb(geom);
        });
      }, me);

      draw.on('drawend', function () {
        // unset sketch
        sketch = null;
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_ol_Observable_js__["b" /* unByKey */])(listener);
      }, me);

      // make draw interaction available as member
      me.draw = draw;
    }

    /**
     * Removes the current interaction and clears the values.
     */

  }, {
    key: 'removeInteraction',
    value: function removeInteraction() {
      var me = this;
      if (me.draw) {
        me.map.removeInteraction(me.draw);
      }
      if (me.source) {
        me.source.clear();
      }
    }
  }]);

  return OlMeasureController;
}();

/* harmony default export */ __webpack_exports__["a"] = (OlMeasureController);

/***/ }),

/***/ "Vxe6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',_vm._l((_vm.layerItems),function(layerItem){return _c('v-list-item',{key:layerItem.lid,staticClass:"wgu-layerlist-item",on:{"click":function($event){return _vm.onItemClick($event, layerItem)}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(layerItem.visible),expression:"layerItem.visible"}],key:layerItem.lid,staticClass:"wgu-layer-viz-cb",attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(layerItem.visible)?_vm._i(layerItem.visible,null)>-1:(layerItem.visible)},on:{"change":[function($event){var $$a=layerItem.visible,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(layerItem, "visible", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(layerItem, "visible", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(layerItem, "visible", $$c)}},_vm.layerVizChanged]}}),_vm._v(" "),_c('v-list-item-content',{staticClass:"black--text"},[_c('v-list-item-title',[_vm._v(_vm._s(layerItem.title))])],1)],1)}),1)}
var staticRenderFns = []


/***/ }),

/***/ "WFjz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mapable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__ = __webpack_require__("ZkkH");


/**
 * Mixin, which binds the OL map to the target component.
 * Executes the onMapBound function of the target component, if available.
 */
var Mapable = {
  created: function created() {
    var _this = this;

    // if the OL map is not present in the vue prototype we have to wait until
    // it is mounted. Otherwise apply OL map as member var.
    if (!this.$map) {
      // apply OL map once OL map is mounted
      __WEBPACK_IMPORTED_MODULE_0__WguEventBus_js__["a" /* WguEventBus */].$on('ol-map-mounted', function (olMap) {
        // make the OL map accessible in this component
        _this.map = olMap;

        if (_this.onMapBound) {
          _this.onMapBound();
        }
      });
    } else {
      // OL map is already mounted --> directly apply as member
      this.map = this.$map;
      if (this.onMapBound) {
        this.onMapBound();
      }
    }
  }
};

/***/ }),

/***/ "WaAR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HelpWin__ = __webpack_require__("UkhJ");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-helpwin-btn',
  components: {
    'wgu-helpwin': __WEBPACK_IMPORTED_MODULE_0__HelpWin__["a" /* default */]
  },
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    icon: { type: String, required: false, default: 'help' },
    text: { type: String, required: false },
    dark: { type: Boolean, required: false, default: false },
    headline: { type: String, required: false },
    content: { type: String, required: false },
    infoLink: { type: String, required: false },
    infoLinkText: { type: String, required: false }
  },
  data: function data() {
    return {
      show: false
    };
  }
});

/***/ }),

/***/ "ZY9t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PropertyTable_vue__ = __webpack_require__("v4OI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aac421b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__ = __webpack_require__("r7zV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("FO/s")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PropertyTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aac421b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aac421b6_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyTable_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZcvY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card',{directives:[{name:"draggable-win",rawName:"v-draggable-win",value:(_vm.draggable),expression:"draggable"}],staticClass:"wgu-layerlist",style:({ left: _vm.left, top: _vm.top})},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-app-bar-nav-icon',{on:{"click":function($event){_vm.show=false}}},[_c('v-icon',[_vm._v("close ")])],1)],1),_vm._v(" "),_c('wgu-layerlist')],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "Ze2P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn-toggle',{attrs:{"mandatory":""},model:{value:(_vm.measureTypeData),callback:function ($$v) {_vm.measureTypeData=$$v},expression:"measureTypeData"}},[_c('v-btn',{attrs:{"large":"","value":"distance"}},[_vm._v("\n     Distance\n   ")]),_vm._v(" "),_c('v-btn',{attrs:{"large":"","value":"area"}},[_vm._v("\n     Area\n   ")])],1)}
var staticRenderFns = []


/***/ }),

/***/ "ZfcG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__ = __webpack_require__("kJWX");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d19fa86_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__ = __webpack_require__("gnDZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("kN+9")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d19fa86"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d19fa86_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d19fa86_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppFooter_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZkkH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WguEventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");



// Vue instance acting as app-wide event-bus
var WguEventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ "asVY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"300","hide-overlay":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"icon":"","dark":"dark"}},on),[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))])],1),_vm._v("\n     "+_vm._s(_vm.text)+"\n   ")]}}]),model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_vm._v(" "),_c('wgu-helpwin',{ref:"helpwin",attrs:{"color":_vm.color,"icon":_vm.icon,"title":_vm.text,"headline":_vm.headline,"content":_vm.content,"infoLink":_vm.infoLink,"infoLinkText":_vm.infoLinkText},on:{"winxclose":function($event){_vm.show=false}}})],1)}
var staticRenderFns = []


/***/ }),

/***/ "avt2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bSi1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bmt2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('v-card',{directives:[{name:"draggable-win",rawName:"v-draggable-win",value:(_vm.draggable),expression:"draggable"}],staticClass:"wgu-infoclick-win",style:({ left: _vm.left, top: _vm.top })},[_c('v-toolbar',{attrs:{"color":_vm.color,"dark":""}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_c('v-toolbar-title',{staticClass:"wgu-win-title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-app-bar-nav-icon',{on:{"click":function($event){_vm.show = false}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"wgu-infoclick-win-title",attrs:{"primary-title":""}},[(!this.attributeData && !this.coordsData)?_c('div',{staticClass:"no-data"},[_vm._v("\n      Click on the map to get information for the clicked map position.\n    ")]):_vm._e(),_vm._v(" "),_c('wgu-property-table',{attrs:{"properties":_vm.attributeData,"color":_vm.color}}),_vm._v(" "),_c('wgu-coords-table',{attrs:{"coordsData":_vm.coordsData,"color":_vm.color}})],1)],1):_vm._e()}
var staticRenderFns = []


/***/ }),

/***/ "bv4e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LayerListWin__ = __webpack_require__("29fi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-layerlist-btn',
  components: {
    'wgu-layerlist-win': __WEBPACK_IMPORTED_MODULE_1__LayerListWin__["a" /* default */]
  },
  props: {
    icon: { type: String, required: false, default: 'layers' },
    text: { type: String, required: false, default: '' },
    dark: { type: Boolean, required: false, default: false }
  },
  data: function data() {
    return {
      moduleName: 'wgu-layerlist'
    };
  },
  created: function created() {
    var me = this;
    // TODO move to a father class
    console.log('on');
    __WEBPACK_IMPORTED_MODULE_2__WguEventBus__["a" /* WguEventBus */].$on('app-mounted', function () {
      me.win = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.cmpLookup[me.moduleName + '-win'];
    });
    if (!me.win) {
      me.win = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.cmpLookup[me.moduleName + '-win'];
    }
  },

  methods: {
    toggleUi: function toggleUi() {
      console.log(this.win);
      // TODO move to a father class
      this.win.show = !this.win.show;
    }
  }
});

/***/ }),

/***/ "c0QU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguAppTemplate_vue__ = __webpack_require__("04/i");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36697f9e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__ = __webpack_require__("1Sz8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguAppTemplate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36697f9e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36697f9e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguAppTemplate_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cspx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureResult_vue__ = __webpack_require__("F+zM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c28dd9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__ = __webpack_require__("EJOe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("0zZl")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureResult_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c28dd9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c28dd9d_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureResult_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "dMML":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wgu-app-tpl',[_c('div',{attrs:{"slot":"wgu-tb-after-title"},slot:"wgu-tb-after-title"},[_c('v-img',{attrs:{"contain":"","height":"50","width":"50","src":"static/data/wnstr-reise/deutsche-weinstrasse.svg"}})],1),_vm._v(" "),_c('wsr-infowin',{attrs:{"slot":"wgu-tb-after-auto-buttons","color":_vm.baseColor},slot:"wgu-tb-after-auto-buttons"}),_vm._v(" "),_c('wsr-sidebar',{ref:"rightSidebar",attrs:{"slot":"wgu-after-header","value":_vm.showRightSidebar,"color":_vm.baseColor},on:{"toggle":function($event){_vm.showRightSidebar=$event}},slot:"wgu-after-header"})],1)}
var staticRenderFns = []


/***/ }),

/***/ "dwOX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.toggleUi}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []


/***/ }),

/***/ "eRtg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoWin_vue__ = __webpack_require__("CHdZ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d833429a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWin_vue__ = __webpack_require__("K3zS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("lv4B")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d833429a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d833429a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d833429a_hasScoped_true_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eTap":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fIFi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Util class for OL layers
 */
var LayerUtil = {
  /**
   * Returns a set of map layers which matches the given key value pair.
   *
   * @param {String} key - Key to filter layers
   * @param {Object} value - Value to filter layers
   * @param  {ol.Map} olMap  The OL map to search in
   * @return {ol.layer.Base[]} Array of matching layers
   */
  getLayersBy: function getLayersBy(key, value, olMap) {
    if (!olMap) {
      console.warn('No OL map passed to LayerUtil.getLayersBy - ' + 'no layer detection possible!');
      return [];
    }

    var layerMatches = [];
    olMap.getLayers().forEach(function (layer) {
      if (layer.get(key) === value) {
        layerMatches.push(layer);
      }
    });

    return layerMatches;
  },


  /**
   * Returns a map layer with the given LID (Layer ID)
   *
   * @param  {String} lid    The LID of the layer to query
   * @param  {ol.Map} olMap  The OL map to search in
   * @return {ol.layer.Base} The OL layer instance or undefined
   */
  getLayerByLid: function getLayerByLid(lid, olMap) {
    return LayerUtil.getLayersBy('lid', lid, olMap)[0];
  },


  /**
   * Zooms to the given layer's extent.
   * Will only work if the layer has kind of vector source.
   *
   * @param  {ol.layer.Base} vecLayer OL vector layer
   * @param  {ol.Map} olMap           The map to perform the zoom on
   */
  zoomToLayerExtent: function zoomToLayerExtent(vecLayer, olMap) {
    if (!vecLayer || !vecLayer.getSource().getExtent || !olMap) {
      return;
    }
    var extent = vecLayer.getSource().getExtent();
    olMap.getView().fit(extent);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (LayerUtil);

/***/ }),

/***/ "fT5P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OlStyleFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__ = __webpack_require__("hiCB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ol_style__ = __webpack_require__("beD/");




/**
 * Factory, which creates OpenLayers style instances according to a given config
 * object.
 * This only covers a minimal subset of the OpenLayers style capabilities.
 * It allows to create simple styles for points, line and polygons.
 * For advanced styling use a custom style function or
 * GeoStyler<https://github.com/terrestris/geostyler>
 */
var OlStyleFactory = {

  /**
   * Returns an OpenLayers Style instance due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL Style instance
   */
  getInstance: function getInstance(styleConf) {
    var style = void 0;
    if (!styleConf) {
      return;
    } else if (styleConf.radius || styleConf.iconUrl) {
      style = OlStyleFactory.createPointStyle(styleConf);
    } else if (styleConf.fillColor) {
      style = OlStyleFactory.createPolygonStyle(styleConf);
    } else if (styleConf.strokeColor || styleConf.strokeWidth) {
      style = OlStyleFactory.createLineStyle(styleConf);
    }

    if (styleConf.label && styleConf.label.attribute && styleConf.label.attribute !== '') {
      // use an OL style function to enable labels
      return OlStyleFactory.getTextStyleFunction(style, styleConf.label);
    }

    return style;
  },


  /**
   * Returns an OpenLayers style instance for point due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createPointStyle: function createPointStyle(styleConf) {
    var pointStyle = void 0;
    if (styleConf.iconUrl) {
      pointStyle = new __WEBPACK_IMPORTED_MODULE_2_ol_style__["b" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["a" /* Icon */]({
          src: styleConf.iconUrl,
          scale: styleConf.scale || 1,
          anchor: styleConf.iconAnchor,
          anchorXUnits: styleConf.iconAnchorXUnits,
          anchorYUnits: styleConf.iconAnchorYUnits
        })
      });
    } else {
      pointStyle = new __WEBPACK_IMPORTED_MODULE_2_ol_style__["b" /* Style */]({
        image: new __WEBPACK_IMPORTED_MODULE_2_ol_style__["c" /* Circle */]({
          radius: styleConf.radius,
          fill: OlStyleFactory.createFill(styleConf),
          stroke: OlStyleFactory.createStroke(styleConf)
        })
      });
    }

    return pointStyle;
  },


  /**
   * Returns an OpenLayers style instance for lines due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createLineStyle: function createLineStyle(styleConf) {
    var olStyle = new __WEBPACK_IMPORTED_MODULE_2_ol_style__["b" /* Style */]({
      stroke: OlStyleFactory.createStroke(styleConf)
    });

    return olStyle;
  },


  /**
   * Returns an OpenLayers style instance for polygons due to given config.
   *
   * @param  {Object} styleConf  Style config object
   * @return {Style}             OL style instance
   */
  createPolygonStyle: function createPolygonStyle(styleConf) {
    var olStyle = OlStyleFactory.createLineStyle(styleConf);
    olStyle.setFill(OlStyleFactory.createFill(styleConf));

    return olStyle;
  },


  /**
   * Creates an OL Stroke object due to given config.
   *
   * @param  {Object} styleConf Style config object
   * @return {Stroke}           OL Stroke instance
   */
  createStroke: function createStroke(styleConf) {
    return new __WEBPACK_IMPORTED_MODULE_2_ol_style__["d" /* Stroke */]({
      color: styleConf.strokeColor,
      width: styleConf.strokeWidth
    });
  },


  /**
   * Creates an OL Fill object due to given config.
   *
   * @param  {Object} styleConf Style config object
   * @return {Fill}             OL Fill instance
   */
  createFill: function createFill(styleConf) {
    return new __WEBPACK_IMPORTED_MODULE_2_ol_style__["e" /* Fill */]({
      color: styleConf.fillColor
    });
  },


  /**
   * Creates and returns a basic OL style object for texts.
   *
   * @param {Object} labelConf Style config object for labels
   * @returns {ol/style/Text} The OL style object for texts
   */
  getTextStyle: function getTextStyle(labelConf) {
    // create a clone to avoid unwanted in place modification
    var textConf = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, labelConf);

    textConf.fill = new __WEBPACK_IMPORTED_MODULE_2_ol_style__["e" /* Fill */]({ color: textConf.fillColor });
    textConf.stroke = new __WEBPACK_IMPORTED_MODULE_2_ol_style__["d" /* Stroke */]({
      color: textConf.outlineColor,
      width: textConf.outlineWidth
    });

    var textStyle = new __WEBPACK_IMPORTED_MODULE_2_ol_style__["f" /* Text */](textConf);

    return textStyle;
  },


  /**
   * Wraps the given OL style as function and injects a text style symbolizer
   * in order to show a label at the feature.
   *
   * @param {ol/style/Style} style
   * @param {Object} labelStyleConf
   * @returns {ol/style/Style~StyleFunction}
   *    Style function returning the OL style object enriched by texts / labels
   */
  getTextStyleFunction: function getTextStyleFunction(style, labelStyleConf) {
    var labelStyle = OlStyleFactory.getTextStyle(labelStyleConf);
    var labelAttr = labelStyleConf.attribute;
    return function (feature, resolution) {
      // detect min/max resolution to show labels
      // if nothing is configured labels are shown regardless of resolution
      var minRes = labelStyleConf.minResolution || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_max_safe_integer___default.a;
      var maxRes = labelStyleConf.maxResolution || 0;
      if (resolution < minRes && resolution > maxRes) {
        // set text to display
        labelStyle.setText(feature.get(labelAttr));
        // apply text style to overall style object
        style.setText(labelStyle);
      } else {
        labelStyle.setText(null);
      }

      return style;
    };
  }
};

/***/ }),

/***/ "gnDZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"color":_vm.color,"app":""}},[_c('span',{staticClass:"wgu-footer-left wst-footer-link-left",domProps:{"innerHTML":_vm._s(_vm.footerTextLeft)}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('div',{staticClass:"wgu-footer-right"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.footerTextRight)}}),_vm._v(" "),(_vm.showCopyrightYear)?_c('span',[_vm._v("© "+_vm._s(new Date().getFullYear()))]):_vm._e()])],1)}
var staticRenderFns = []


/***/ }),

/***/ "gxed":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__src_components_layerlist_ToggleButton__ = __webpack_require__("UAgb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__src_components_helpwin_ToggleButton__ = __webpack_require__("1SaT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__src_components_measuretool_ToggleButton__ = __webpack_require__("uwYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__src_components_infoclick_ToggleButton__ = __webpack_require__("NkLf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__src_components_maxextentbutton_ZoomToMaxExtentButton__ = __webpack_require__("qqRY");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-header',
  components: {
    'wgu-zoomtomaxextent-btn': __WEBPACK_IMPORTED_MODULE_7__src_components_maxextentbutton_ZoomToMaxExtentButton__["a" /* default */],
    'wgu-layerlist-btn': __WEBPACK_IMPORTED_MODULE_3__src_components_layerlist_ToggleButton__["a" /* default */],
    'wgu-helpwin-btn': __WEBPACK_IMPORTED_MODULE_4__src_components_helpwin_ToggleButton__["a" /* default */],
    'wgu-measuretool-btn': __WEBPACK_IMPORTED_MODULE_5__src_components_measuretool_ToggleButton__["a" /* default */],
    'wgu-infoclick-btn': __WEBPACK_IMPORTED_MODULE_6__src_components_infoclick_ToggleButton__["a" /* default */]
  },
  props: {
    color: { type: String, required: false, default: 'red darken-3' }
  },
  data: function data() {
    return {
      title: this.$appConfig.title,
      menuButtons: this.getModuleButtonData(),
      tbButtons: this.getToolbarButtons()
    };
  },

  methods: {
    /**
     * Determines the module menu button configuration objects from app-config:
     *    menuButtons: [
     *      {type: 'wgu-layerlist-toggle-btn'},
     *      {type: 'wgu-helpwin-toggle-btn'},
     *      {type: 'wgu-measuretool-toggle-btn'}
     *    ]
     * @return {Array} module button configuration objects for the menu
     */
    getModuleButtonData: function getModuleButtonData() {
      var appConfig = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig;
      var moduleWins = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(appConfig.modules)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var key = _step.value;

          var moduleOpts = appConfig.modules[key];
          if (moduleOpts.target === 'menu') {
            moduleWins.push({
              type: key + '-btn',
              target: moduleOpts.target
            });
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return moduleWins;
    },

    /**
     * Determines the module toolbar button configuration objects from app-config:
     *    menuButtons: [
     *      {type: 'wgu-layerlist-toggle-btn'},
     *      {type: 'wgu-helpwin-toggle-btn'},
     *      {type: 'wgu-measuretool-toggle-btn'}
     *    ]
     * @return {Array} module button configuration objects for the toolbar
     */
    getToolbarButtons: function getToolbarButtons() {
      var appConfig = __WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.$appConfig;
      var moduleWins = [];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(appConfig.modules)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var key = _step2.value;

          var moduleOpts = appConfig.modules[key];
          if (moduleOpts.target === 'toolbar') {
            moduleWins.push({
              type: key + '-btn',
              target: moduleOpts.target,
              dark: moduleOpts.darkLayout
            });
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return moduleWins;
    }
  }
});

/***/ }),

/***/ "i8bC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__ = __webpack_require__("UdpQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72125545_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__ = __webpack_require__("pfbC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("/Y57")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72125545_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72125545_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Map_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "irkU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MeasureWin__ = __webpack_require__("lgWu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WguEventBus__ = __webpack_require__("ZkkH");
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-measuretool-btn',
  components: {
    'wgu-measuretool-win': __WEBPACK_IMPORTED_MODULE_1__MeasureWin__["a" /* default */]
  },
  props: {
    icon: { type: String, required: false, default: 'photo_size_select_small' },
    text: { type: String, required: false },
    dark: { type: Boolean, required: false, default: false }
  },
  data: function data() {
    return {
      moduleName: 'wgu-measuretool'
    };
  },
  created: function created() {
    var me = this;
    // TODO move to a father class
    __WEBPACK_IMPORTED_MODULE_2__WguEventBus__["a" /* WguEventBus */].$on('app-mounted', function () {
      me.win = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.cmpLookup[me.moduleName + '-win'];
    });
    if (!me.win) {
      me.win = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.cmpLookup[me.moduleName + '-win'];
    }
  },

  methods: {
    toggleUi: function toggleUi() {
      // TODO move to a father class
      this.win.show = !this.win.show;
    }
  }
});

/***/ }),

/***/ "j++n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.coordRows)?_c('table',{staticClass:"wgu-coordstable",style:(_vm.tableStyles)},[_vm._m(0),_vm._v(" "),_c('tbody',_vm._l((_vm.coordRows),function(value,key){return _c('tr',[_c('td',{staticClass:"key-td"},[_vm._v("\n        "+_vm._s(key)+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"val-td"},[_vm._v("\n        "+_vm._s(value)+"\n      ")])])}),0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr')])}]


/***/ }),

/***/ "kDS9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kJWX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-app-footer',
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    footerTextLeft: { type: String, required: false, default: 'Powered by <a href="https://meggsimum.de/wegue/" target="_blank">Wegue WebGIS</a>' },
    footerTextRight: { type: String, required: false, default: 'meggsimum' },
    showCopyrightYear: { type: Boolean, required: false, default: true }
  }
});

/***/ }),

/***/ "kN+9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ktr9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lPmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","dark":_vm.dark},on:{"click":_vm.toggleUi}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v("\n  "+_vm._s(_vm.text)+"\n")],1)}
var staticRenderFns = []


/***/ }),

/***/ "lQeg":
/***/ (function(module, exports) {

module.exports = {"_args":[["proj4@2.5.0","/home/jakob/Meggsimum/02_Code/weinstrasse/wegue"]],"_from":"proj4@2.5.0","_id":"proj4@2.5.0","_inBundle":false,"_integrity":"sha512-XZTRT7OPdLzgvtTqL8DG2cEj8lYdovztOwiwpwRSYayOty5Ipf3H68dh/fiL+HKDEyetmQSMhkkMGiJoyziz3w==","_location":"/proj4","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"proj4@2.5.0","name":"proj4","escapedName":"proj4","rawSpec":"2.5.0","saveSpec":null,"fetchSpec":"2.5.0"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/proj4/-/proj4-2.5.0.tgz","_spec":"2.5.0","_where":"/home/jakob/Meggsimum/02_Code/weinstrasse/wegue","author":"","bugs":{"url":"https://github.com/proj4js/proj4js/issues"},"contributors":[{"name":"Mike Adair","email":"madair@dmsolutions.ca"},{"name":"Richard Greenwood","email":"rich@greenwoodmap.com"},{"name":"Calvin Metcalf","email":"calvin.metcalf@gmail.com"},{"name":"Richard Marsden","url":"http://www.winwaed.com"},{"name":"T. Mittan"},{"name":"D. Steinwand"},{"name":"S. Nelson"}],"dependencies":{"mgrs":"1.0.0","wkt-parser":"^1.2.0"},"description":"Proj4js is a JavaScript library to transform point coordinates from one coordinate system to another, including datum transformations.","devDependencies":{"chai":"~4.1.2","curl-amd":"github:cujojs/curl","grunt":"^1.0.1","grunt-cli":"~1.2.0","grunt-contrib-connect":"~1.0.2","grunt-contrib-jshint":"~1.1.0","grunt-contrib-uglify":"~3.1.0","grunt-mocha-phantomjs":"~4.0.0","grunt-rollup":"^6.0.0","istanbul":"~0.4.5","mocha":"~4.0.0","rollup":"^0.50.0","rollup-plugin-json":"^2.3.0","rollup-plugin-node-resolve":"^3.0.0","tin":"~0.5.0"},"directories":{"test":"test","doc":"docs"},"homepage":"https://github.com/proj4js/proj4js#readme","license":"MIT","main":"dist/proj4-src.js","module":"lib/index.js","name":"proj4","repository":{"type":"git","url":"git://github.com/proj4js/proj4js.git"},"scripts":{"build":"grunt","build:tmerc":"grunt build:tmerc","test":"npm run build && istanbul test _mocha test/test.js"},"version":"2.5.0"}

/***/ }),

/***/ "lgWu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureWin_vue__ = __webpack_require__("4z3x");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b8dd48_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__ = __webpack_require__("6vBf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("qxa+")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b8dd48_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00b8dd48_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "lv4B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mUig":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__ = __webpack_require__("gxed");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db748f62_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__ = __webpack_require__("+rGV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("97QL")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db748f62_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_db748f62_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppHeader_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "mucN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerList_vue__ = __webpack_require__("VLBH");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b8d9fd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__ = __webpack_require__("Vxe6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("0lwK")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LayerList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b8d9fd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_49b8d9fd_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LayerList_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nF/d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Util class for color related things.
 */
var ColorUtil = {
  /**
   * Detects whether a given string is a CSS color notation.
   *
   * @param {String} color (Color) string to test
   * @return {Boolean} true if given string is in CSS color notation
   */
  isCssColor: function isCssColor(color) {
    return !!color && !!color.match(/^(#|(rgb|hsl)a?\()/);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (ColorUtil);

/***/ }),

/***/ "novK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLoadingStatus_vue__ = __webpack_require__("RAvm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73928fe2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__ = __webpack_require__("zqHZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("1jdk")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MapLoadingStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73928fe2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73928fe2_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MapLoadingStatus_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pfbC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []


/***/ }),

/***/ "qUL7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoClickWin_vue__ = __webpack_require__("Nkpt");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6675716e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__ = __webpack_require__("bmt2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("tTN7")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InfoClickWin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6675716e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6675716e_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InfoClickWin_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qq5n":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLogo_vue__ = __webpack_require__("P5f+");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41611896_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__ = __webpack_require__("6yqd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("eTap")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AppLogo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41611896_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41611896_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AppLogo_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qqRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomToMaxExtentButton_vue__ = __webpack_require__("ypcs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25aa3fc0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__ = __webpack_require__("DIZr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("+5KU")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomToMaxExtentButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25aa3fc0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25aa3fc0_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomToMaxExtentButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qxa+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r7zV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.properties)?_c('table',{staticClass:"wgu-proptable",style:(_vm.tableStyles)},[_vm._m(0),_vm._v(" "),_c('tbody',{staticClass:"attr-tbody"},_vm._l((_vm.properties),function(value,key){return _c('tr',[_c('td',{staticClass:"key-td"},[_vm._v("\n        "+_vm._s(key)+"\n      ")]),_vm._v(" "),_c('td',{staticClass:"val-td"},[_vm._v("\n        "+_vm._s(value)+"\n      ")])])}),0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr')])}]


/***/ }),

/***/ "tTN7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uACE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_WguEventBus__ = __webpack_require__("ZkkH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_Device__ = __webpack_require__("y65X");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wsr-startscreen',
  components: {},
  props: {},
  data: function data() {
    return {
      showMe: true
    };
  },

  computed: {
    isMobile: function isMobile() {
      return __WEBPACK_IMPORTED_MODULE_1__util_Device__["a" /* Device */].isMobile();
    }
  },
  watch: {
    showMe: function showMe(val) {
      if (val === false) {
        __WEBPACK_IMPORTED_MODULE_0__src_WguEventBus__["a" /* WguEventBus */].$emit('wsr-sidebar-hide');
      }
    }
  }
});

/***/ }),

/***/ "uwYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__ = __webpack_require__("irkU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d60f71c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__ = __webpack_require__("3h5C");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("UZyY")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ToggleButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d60f71c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d60f71c4_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ToggleButton_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "v4OI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors__ = __webpack_require__("IHMs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_Color__ = __webpack_require__("nF/d");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-property-table',
  props: {
    color: { type: String, required: false, default: 'red darken-3' },
    properties: { type: Object }
  },
  computed: {
    tableStyles: function tableStyles() {
      // calculate border color of tables due to current color property
      var borderColor = this.color;
      if (!__WEBPACK_IMPORTED_MODULE_2__util_Color__["a" /* default */].isCssColor(this.color)) {
        var _color$toString$trim$ = this.color.toString().trim().split(' ', 2),
            _color$toString$trim$2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_color$toString$trim$, 2),
            colorName = _color$toString$trim$2[0],
            colorModifier = _color$toString$trim$2[1];

        borderColor = __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default.a[colorName];
        if (colorModifier) {
          colorModifier = colorModifier.replace('-', '');
          borderColor = __WEBPACK_IMPORTED_MODULE_1_vuetify_es5_util_colors___default.a[colorName][colorModifier];
        }
      }
      return {
        'border': '2px solid ' + borderColor
      };
    }
  }
});

/***/ }),

/***/ "v9hS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__("d7EF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);



/**
 * URL related util methods
 */
var UrlUtil = {

  /**
   * Parses query string like a=b&c=d&e=f etc of the given search part (querySearch) of an URL
   * as JS object (key-value). Uses ES6 coding/parsing as in:
   * https://www.arungudelli.com/tutorial/javascript/get-query-string-parameter-values-from-url-using-javascript/
   *
   * @param  {String} query Search part (queryString) of an URL
   * @return {Object}             Key-value pairs of the URL parameters
   */
  parseQueryString: function parseQueryString(query) {
    return (/^[?#]/.test(query) ? query.slice(1) : query).split('&').reduce(function (params, param) {
      var _param$split = param.split('='),
          _param$split2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_param$split, 2),
          key = _param$split2[0],
          value = _param$split2[1];

      params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
      return params;
    }, {});
  },


  /**
   * Returns the query params of the current 'location' from 'hash' or 'search'.
   *
   * @param  {String} locationType use query or hash part of URL
   * @return {Object}             Key-value pairs of the URL parameters
   */
  getParams: function getParams(locationType) {
    var querySearch = document.location[locationType].substring(1);
    if (!querySearch || querySearch === '') {
      return {};
    }
    return this.parseQueryString(querySearch);
  },


  /**
   * Returns all query params of the given search part (querySearch) of an URL
   * as JS object (key-value).
   * If querySearch is not provided it is derived from the current location.
   *
   * @param  {String} querySearch Search part (querySearch) of an URL
   * @return {Object} Key-value pairs of the URL parameters, may be empty {}.
   */
  getQueryParams: function getQueryParams(querySearch) {
    if (!querySearch) {
      querySearch = document.location.search.substring(1);
    }

    if (!querySearch || querySearch === '') {
      return {};
    }

    return this.parseQueryString(querySearch);
  },


  /**
   * Returns all query params of the given hash part (hash) of an URL
   * as JS object (key-value).
   * If hash is not provided it is derived from the current location.
   *
   * @param  {String} hash Search part (hash) of an URL
   * @return {Object} Key-value pairs of the URL parameters
   */
  getHashParams: function getHashParams(hash) {
    if (!hash) {
      hash = document.location.hash.substring(1);
    }

    return this.parseQueryString(hash);
  },


  /**
   * Returns a dedicated URL parameter if existing.
   * If querySearch is not provided it is derived from the current location.
   *
   * @param  {String} param       The URL param name
   * @param  {String} querySearch Search part (querySearch) of an URL
   * @return {String}             Value of the given URL param
   */
  getQueryParam: function getQueryParam(param, querySearch) {
    var params = this.getQueryParams(querySearch);
    var value = void 0;
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(params).forEach(function (key) {
      if (key === param) {
        value = params[key];
      }
    });

    return value;
  },


  /**
   * Returns a query string from an object of key/value pairs.
   *
   * @param  {String} obj object with key/values to encode.
   * @return {String} the encoded query string
   */
  toQueryString: function toQueryString(obj) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj).reduce(function (a, k) {
      a.push(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(obj[k]) === 'object' ? _this.toQueryString(obj[k]) : encodeURIComponent(k) + '=' + encodeURIComponent(obj[k]));
      return a;
    }, []).join('&');
  }
};

/* harmony default export */ __webpack_exports__["a"] = (UrlUtil);

/***/ }),

/***/ "w/12":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureTypeChooser_vue__ = __webpack_require__("TooU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d2b4819_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__ = __webpack_require__("Ze2P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("bSi1")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeasureTypeChooser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d2b4819_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d2b4819_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MeasureTypeChooser_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y+0P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguApp_vue__ = __webpack_require__("GgOu");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79008d38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__ = __webpack_require__("dMML");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__ = __webpack_require__("XyMi");
function injectStyle (context) {
  __webpack_require__("+u1G")
}
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null

var Component = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__node_modules_vue_loader_lib_runtime_component_normalizer__["a" /* default */])(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WguApp_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79008d38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__["a" /* render */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79008d38_hasScoped_false_optionsId_0_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WguApp_vue__["b" /* staticRenderFns */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "y65X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Device; });

var Device = {
  isMobile: function isMobile() {
    var check = false;
    (function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    return check;
  }
};

/***/ }),

/***/ "yRk2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-navigation-drawer',{attrs:{"app":"","right":"","clipped":"","mobile-break-point":"670","width":"450","mini-variant-width":"300"},model:{value:(_vm.showMe),callback:function ($$v) {_vm.showMe=$$v},expression:"showMe"}},[(_vm.showStartscreen)?_c('wsr-startscreen'):_vm._e(),_vm._v(" "),(!_vm.showStartscreen)?_c('v-card',{staticClass:"info-card"},[_c('v-img',{attrs:{"src":_vm.imgPath,"aspect-ratio":"1.5"}}),_vm._v(" "),_c('v-card-title',{staticClass:"wsr-text",attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',[_vm._v(" "+_vm._s(_vm.description)+" ")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"15px"}},[_c('br'),_vm._v(" "),(_vm.website)?_c('span',[_vm._v("\n            Zum vollständigen "),_c('a',{attrs:{"href":_vm.website,"target":"_blank"}},[_vm._v("Wikipedia-Artikel")])]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"smaller"}},[_vm._v("Quelle Foto und Text: Wikipedia")])])])]),_vm._v(" "),(_vm.isMobile)?_c('v-card-actions',[_c('v-btn',{attrs:{"flat":"","color":"gray"},on:{"click":function($event){_vm.showMe=false}}},[_vm._v("Zur Karte")])],1):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []


/***/ }),

/***/ "ypcs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__ = __webpack_require__("WFjz");
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'wgu-zoomtomaxextent-btn',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_Mapable__["a" /* Mapable */]],
  props: {
    icon: { type: String, required: false, default: 'zoom_out_map' },
    text: { type: String, required: false, default: '' },
    dark: { type: Boolean, required: false, default: false }
  },
  methods: {
    onClick: function onClick() {
      // derive correct initial zoom and center
      var initialCenter = this.$appConfig.mapCenter;
      var initalZoom = this.$appConfig.mapZoom;
      this.map.getView().setCenter(initialCenter);
      this.map.getView().setZoom(initalZoom);
    }
  }
});

/***/ }),

/***/ "zqHZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return render; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return staticRenderFns; });
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('v-progress-circular',{staticClass:"wgu-maploading-status",attrs:{"value":80,"indeterminate":"","color":_vm.color}}):_vm._e()}
var staticRenderFns = []


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.370f558305a75bd57d1a.js